import * as i0 from '@angular/core';
import { Pipe, input, EventEmitter, Output, Component, Injectable, ViewChild, NgModule, signal, Input, computed } from '@angular/core';
import * as i1 from '@nimmsta/ng-commons-lib';
import { NimmstaDataSource, Column, WorkflowDataService, NimmstaCommonsModule, OrganizationService, ConfigurationDataService, SaveableFormComponent, IconAction, ServiceType, DataTableComponent, UserRole, UserStatus, IMPERSONATION_SESSION_STORAGE_KEY, CustomAction, launchImpersonationInNewTab, OrganizationStatus, OrganizationType, Organization, WorkerStatus, TabComponent, StatusBadgePipe } from '@nimmsta/ng-commons-lib';
import * as i2 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import * as i3 from '@angular/common';
import { Md5 } from 'ts-md5';
import { jsPDF } from 'jspdf';
import * as i3$1 from 'ngx-bootstrap/modal';
import * as i5 from 'angular2-ladda';
import * as i7 from '@angular/material/progress-spinner';
import * as i8 from 'angularx-qrcode';
import { QRCodeModule } from 'angularx-qrcode';
import { switchMap, lastValueFrom, of, tap, map } from 'rxjs';
import { HttpParams, HttpErrorResponse } from '@angular/common/http';
import * as i1$1 from '@angular/forms';
import { Validators, FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import * as i1$2 from '@angular/router';
import * as i6 from 'primeng/dropdown';
import { DropdownModule } from 'primeng/dropdown';
import * as i7$1 from 'primeng/api';
import * as i4 from 'ngx-bootstrap/tabs';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { MultiSelectModule } from 'primeng/multiselect';

class OrganizationTypePipe {
    constructor(translateService) {
        this.translateService = translateService;
    }
    transform(value) {
        if (!value) {
            return '-';
        }
        return this.translateService.instant(`organizations.typeItems.${value}`);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: OrganizationTypePipe, deps: [{ token: i2.TranslateService }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: OrganizationTypePipe, name: "organizationType" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: OrganizationTypePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'organizationType' }]
        }], ctorParameters: () => [{ type: i2.TranslateService }] });

class OrganizationSelectorComponent {
    constructor(service, typePipe) {
        this.service = service;
        this.typePipe = typePipe;
        this.type = input();
        this.orgSelected = new EventEmitter();
    }
    ngOnInit() {
        this.datasource = new NimmstaDataSource(this.service);
        if (this.type()) {
            this.datasource.defaultFilter = [`type:${this.type()}-or`];
        }
    }
    get columns() {
        const cols = [
            new Column('name', 'organizations.name', { sortable: true }),
            new Column('description', 'organizations.description', { sortable: true }),
            new Column('address', 'organizations.address', { sortable: true }),
        ];
        if (!this.type()) {
            cols.push(new Column('type', 'organizations.type', { sortable: true, pipe: this.typePipe }));
        }
        return cols;
    }
    selectOrg(orgId) {
        const org = this.datasource?.data?.content.find((r) => r.id === orgId);
        if (org === undefined) {
            // TODO: handle error
            throw new Error('Org not found');
        }
        this.orgSelected.emit(org);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: OrganizationSelectorComponent, deps: [{ token: i1.OrganizationService }, { token: OrganizationTypePipe }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.1.0", version: "18.2.13", type: OrganizationSelectorComponent, selector: "app-organization-selector", inputs: { type: { classPropertyName: "type", publicName: "type", isSignal: true, isRequired: false, transformFunction: null } }, outputs: { orgSelected: "orgSelected" }, ngImport: i0, template: "<h5 translate>organizations.selectorTitle</h5>\n<app-datatable [dataSource]=\"datasource\"\n               [identifier]=\"'organizationSelector'\"\n               [isMainTable]=\"false\"\n               [columns]=\"columns\"\n               [actionNew]=\"false\"\n               [searchEnabled]=\"false\"\n               (showEvent)=\"selectOrg($event.valueOf())\"\n               *ngIf=\"datasource\"\n>\n    <app-empty-table\n        [icon]=\"'lab_profile'\"\n        [emptyText]=\"'organizations.empty_text' | translate\"\n    ></app-empty-table>\n</app-datatable>\n", dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.TranslateDirective, selector: "[translate],[ngx-translate]", inputs: ["translate", "translateParams"] }, { kind: "component", type: i1.DataTableComponent, selector: "app-datatable", inputs: ["dataSource", "columns", "identifier", "actionNew", "customActions", "iconActions", "btnClass", "customTableActions", "isMainTable", "loadOnInit", "searchEnabled", "showPagination", "defaultPageSize", "defaultSortName", "defaultSortDirection"], outputs: ["showEvent", "newEvent"] }, { kind: "component", type: i1.EmptyTableComponent, selector: "app-empty-table", inputs: ["icon", "emptyText", "buttonText"], outputs: ["btnClick"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: OrganizationSelectorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-organization-selector', template: "<h5 translate>organizations.selectorTitle</h5>\n<app-datatable [dataSource]=\"datasource\"\n               [identifier]=\"'organizationSelector'\"\n               [isMainTable]=\"false\"\n               [columns]=\"columns\"\n               [actionNew]=\"false\"\n               [searchEnabled]=\"false\"\n               (showEvent)=\"selectOrg($event.valueOf())\"\n               *ngIf=\"datasource\"\n>\n    <app-empty-table\n        [icon]=\"'lab_profile'\"\n        [emptyText]=\"'organizations.empty_text' | translate\"\n    ></app-empty-table>\n</app-datatable>\n" }]
        }], ctorParameters: () => [{ type: i1.OrganizationService }, { type: OrganizationTypePipe }], propDecorators: { orgSelected: [{
                type: Output
            }] } });

var QRStatus;
(function (QRStatus) {
    QRStatus["ACTIVE"] = "ACTIVE";
    QRStatus["INACTIVE"] = "INACTIVE";
    QRStatus["USED"] = "USED";
})(QRStatus || (QRStatus = {}));

class WorkerService extends WorkflowDataService {
    get apiEndpoint() {
        return '/worker';
    }
    createQRCode(worker, unlimitedUse) {
        return this.http.post(`${this.baseUrl}/auth/QR/${worker.id}`, { unlimitedUse });
    }
    getQRCode(qrCodeId) {
        return this.http.get(`${this.baseUrl}/auth/QR/${qrCodeId}`);
    }
    unpair(worker) {
        return this.http.post(`${this.baseUrl}/worker/${worker.id}/unpair`, {});
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: WorkerService, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: WorkerService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: WorkerService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class PairWorkerModalComponent {
    constructor(workerService, modalRef, configuration) {
        this.workerService = workerService;
        this.modalRef = modalRef;
        this.configuration = configuration;
        this.timeRemaining = 0;
        this.isQRLoading = false;
        this.interval = undefined;
        if (this.configuration.apiUrls.workflow && this.configuration.androidAppSoftwareId) {
            this.latestAppDownloadLink = `${this.configuration.apiUrls.workflow}/api/v1/software/`
                + `${this.configuration.androidAppSoftwareId}/latest-download`;
        }
    }
    ngOnInit() {
        this.modalRef.setClass('modal-sm');
        this.modalRef.onHidden?.subscribe(() => {
            clearInterval(this.interval);
        });
        this.refreshQrCode();
    }
    refreshQrCode() {
        this.qrCode = undefined;
        this.qrCodeId = undefined;
        this.expires = undefined;
        clearInterval(this.interval);
        this.workerService.createQRCode(this.worker, false).subscribe({
            next: (response) => {
                this.qrCode = response.qrCode;
                this.qrCodeId = response.id;
                this.expires = new Date(response.expiresAt);
                this.timeRemaining = this.expires.getTime() - new Date().getTime();
                this.interval = setInterval(() => {
                    this.timeRemaining -= 1000;
                    this.checkUsed();
                    if (this.timeRemaining <= 0) {
                        clearInterval(this.interval);
                    }
                }, 1000);
            },
            error: (error) => {
                this.error = error;
            },
        });
    }
    checkUsed() {
        this.workerService.getQRCode(this.qrCodeId).subscribe({
            next: (response) => {
                if (response.status === QRStatus.USED) {
                    clearInterval(this.interval);
                    this.modalRef.hide();
                }
            },
            error: (error) => {
                this.error = error;
            },
        });
    }
    printQR() {
        this.isQRLoading = true;
        clearInterval(this.interval);
        this.profileImg = `https://www.gravatar.com/avatar/${Md5.hashStr(this.worker.email ?? '')}`;
        this.workerService.createQRCode(this.worker, true).subscribe((response) => {
            this.userQRData = response.qrCode;
            // Wait for Angulars change detection
            setTimeout(() => {
                this.openPDF();
            }, 0);
        });
    }
    openPDF() {
        const content = this.pdfContent.nativeElement;
        // eslint-disable-next-line new-cap
        const pdf = new jsPDF('p', 'px', 'a4');
        pdf.html(content.innerHTML, {
            callback: (doc) => {
                const blob = doc.output('blob');
                window.open(URL.createObjectURL(blob));
                this.isQRLoading = false;
            },
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PairWorkerModalComponent, deps: [{ token: WorkerService }, { token: i3$1.BsModalRef }, { token: i1.NimmstaCommonsModuleConfiguration }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.13", type: PairWorkerModalComponent, selector: "app-pair-worker-modal", viewQueries: [{ propertyName: "pdfContent", first: true, predicate: ["pdfContent"], descendants: true }], ngImport: i0, template: "<div class=\"modal-header\">\n  <h4 class=\"modal-title pull-left\" translate>worker.pair</h4>\n  <button type=\"button\" class=\"btn-close close pull-right\" aria-label=\"Close\" (click)=\"modalRef.hide()\">\n    <span aria-hidden=\"true\" class=\"visually-hidden\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  @if (!qrCode) {\n    <div class=\"d-flex justify-content-center align-content-center pt-2 pb-2\"\n      style=\"height: 25px; padding-top: 10px; background-color: #FFFFFF\">\n      <mat-spinner class=\"position-absolute\" [diameter]=\"25\"></mat-spinner>\n    </div>\n  }\n  @if (qrCode) {\n    <div>\n      <qrcode [qrdata]=\"qrCode\" [width]=\"256\" [errorCorrectionLevel]=\"'M'\"></qrcode>\n      <div>\n        <a (click)=\"refreshQrCode()\" class=\"float-end\" translate>qr_refresh</a>\n        @if (expires) {\n          <span>{{timeRemaining | countdownTimer}}</span>\n        }\n      </div>\n    </div>\n  }\n</div>\n<app-error [error]=\"error\"></app-error>\n<div class=\"modal-footer\">\n  <button type=\"button\" class=\"btn btn-outline-secondary\" (click)=\"modalRef.hide()\" translate>close</button>\n  <button type=\"button\" class=\"btn btn-secondary\" (click)=\"printQR()\" [ladda]=\"isQRLoading\">{{ 'worker.print_qr' | translate }}</button>\n</div>\n\n<!-- PDF Definition -->\n<div #pdfContent class=\"d-none\">\n  <div class=\"page a4\" style=\"padding: 16px;\">\n    <img src=\"./assets/img/logo.png\" width=\"200\">\n    <h4 style=\"margin-left: 110px; margin-top: 48px; width: 320px;\" translate>productivity_cloud</h4>\n    <div style=\"display: flex; margin-top: 32px;\">\n      <div>\n        <h5 style=\"margin-left: 34px\" translate>qr_print_page.download</h5>\n        <h5 style=\"margin-left: 16px\" translate>qr_print_page.app</h5>\n        <qrcode *ngIf=\"latestAppDownloadLink\" [qrdata]=\"latestAppDownloadLink\" [width]=\"160\" [imageHeight]=\"160\" [errorCorrectionLevel]=\"'H'\" [elementType]=\"'img'\" [margin]=\"0\"></qrcode>\n      </div>\n      <div style=\"margin-left: 92px;\">\n        <h5 style=\"margin-left: 56px;\" translate>qr_print_page.login</h5>\n        <h5 style=\"margin-left: 16px;\" translate>qr_print_page.app</h5>\n        @if (userQRData) {\n          <qrcode [qrdata]=\"userQRData\" [width]=\"160\" [imageHeight]=\"160\" [errorCorrectionLevel]=\"'H'\" [elementType]=\"'img'\" [margin]=\"0\"></qrcode>\n        }\n      </div>\n    </div>\n    <div style=\"width: 500px; margin-top: 90px;\">\n      <h5 translate>qr_print_page.worker_detail</h5>\n    </div>\n    <div style=\"display: flex; margin-top: 16px;\">\n      @if (worker.email) {\n        <div style=\"margin-right: 32px;\">\n          <img class=\"rounded-circle\" width=\"80\" height=\"80\" src='{{profileImg}}'>\n        </div>\n      }\n      <div>\n        <h6>{{worker.given_name}} {{worker.family_name}}</h6>\n        @if (worker.email) {\n          <h6>{{worker.email}}</h6>\n        }\n      </div>\n    </div>\n  </div>\n</div>\n", styles: [""], dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5.LaddaDirective, selector: "[ladda]", inputs: ["ladda", "disabled"] }, { kind: "directive", type: i2.TranslateDirective, selector: "[translate],[ngx-translate]", inputs: ["translate", "translateParams"] }, { kind: "component", type: i1.ErrorComponent, selector: "app-error", inputs: ["error"] }, { kind: "component", type: i7.MatProgressSpinner, selector: "mat-progress-spinner, mat-spinner", inputs: ["color", "mode", "value", "diameter", "strokeWidth"], exportAs: ["matProgressSpinner"] }, { kind: "component", type: i8.QRCodeComponent, selector: "qrcode", inputs: ["allowEmptyString", "colorDark", "colorLight", "cssClass", "elementType", "errorCorrectionLevel", "imageSrc", "imageHeight", "imageWidth", "margin", "qrdata", "scale", "version", "width", "alt", "ariaLabel", "title"], outputs: ["qrCodeURL"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }, { kind: "pipe", type: i1.CountdownTimerPipe, name: "countdownTimer" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PairWorkerModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-pair-worker-modal', template: "<div class=\"modal-header\">\n  <h4 class=\"modal-title pull-left\" translate>worker.pair</h4>\n  <button type=\"button\" class=\"btn-close close pull-right\" aria-label=\"Close\" (click)=\"modalRef.hide()\">\n    <span aria-hidden=\"true\" class=\"visually-hidden\">&times;</span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  @if (!qrCode) {\n    <div class=\"d-flex justify-content-center align-content-center pt-2 pb-2\"\n      style=\"height: 25px; padding-top: 10px; background-color: #FFFFFF\">\n      <mat-spinner class=\"position-absolute\" [diameter]=\"25\"></mat-spinner>\n    </div>\n  }\n  @if (qrCode) {\n    <div>\n      <qrcode [qrdata]=\"qrCode\" [width]=\"256\" [errorCorrectionLevel]=\"'M'\"></qrcode>\n      <div>\n        <a (click)=\"refreshQrCode()\" class=\"float-end\" translate>qr_refresh</a>\n        @if (expires) {\n          <span>{{timeRemaining | countdownTimer}}</span>\n        }\n      </div>\n    </div>\n  }\n</div>\n<app-error [error]=\"error\"></app-error>\n<div class=\"modal-footer\">\n  <button type=\"button\" class=\"btn btn-outline-secondary\" (click)=\"modalRef.hide()\" translate>close</button>\n  <button type=\"button\" class=\"btn btn-secondary\" (click)=\"printQR()\" [ladda]=\"isQRLoading\">{{ 'worker.print_qr' | translate }}</button>\n</div>\n\n<!-- PDF Definition -->\n<div #pdfContent class=\"d-none\">\n  <div class=\"page a4\" style=\"padding: 16px;\">\n    <img src=\"./assets/img/logo.png\" width=\"200\">\n    <h4 style=\"margin-left: 110px; margin-top: 48px; width: 320px;\" translate>productivity_cloud</h4>\n    <div style=\"display: flex; margin-top: 32px;\">\n      <div>\n        <h5 style=\"margin-left: 34px\" translate>qr_print_page.download</h5>\n        <h5 style=\"margin-left: 16px\" translate>qr_print_page.app</h5>\n        <qrcode *ngIf=\"latestAppDownloadLink\" [qrdata]=\"latestAppDownloadLink\" [width]=\"160\" [imageHeight]=\"160\" [errorCorrectionLevel]=\"'H'\" [elementType]=\"'img'\" [margin]=\"0\"></qrcode>\n      </div>\n      <div style=\"margin-left: 92px;\">\n        <h5 style=\"margin-left: 56px;\" translate>qr_print_page.login</h5>\n        <h5 style=\"margin-left: 16px;\" translate>qr_print_page.app</h5>\n        @if (userQRData) {\n          <qrcode [qrdata]=\"userQRData\" [width]=\"160\" [imageHeight]=\"160\" [errorCorrectionLevel]=\"'H'\" [elementType]=\"'img'\" [margin]=\"0\"></qrcode>\n        }\n      </div>\n    </div>\n    <div style=\"width: 500px; margin-top: 90px;\">\n      <h5 translate>qr_print_page.worker_detail</h5>\n    </div>\n    <div style=\"display: flex; margin-top: 16px;\">\n      @if (worker.email) {\n        <div style=\"margin-right: 32px;\">\n          <img class=\"rounded-circle\" width=\"80\" height=\"80\" src='{{profileImg}}'>\n        </div>\n      }\n      <div>\n        <h6>{{worker.given_name}} {{worker.family_name}}</h6>\n        @if (worker.email) {\n          <h6>{{worker.email}}</h6>\n        }\n      </div>\n    </div>\n  </div>\n</div>\n" }]
        }], ctorParameters: () => [{ type: WorkerService }, { type: i3$1.BsModalRef }, { type: i1.NimmstaCommonsModuleConfiguration }], propDecorators: { pdfContent: [{
                type: ViewChild,
                args: ['pdfContent']
            }] } });

class ComponentsModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ComponentsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: ComponentsModule, declarations: [PairWorkerModalComponent, OrganizationSelectorComponent], imports: [NimmstaCommonsModule, QRCodeModule], exports: [PairWorkerModalComponent, OrganizationSelectorComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ComponentsModule, imports: [NimmstaCommonsModule, QRCodeModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ComponentsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [NimmstaCommonsModule, QRCodeModule],
                    declarations: [PairWorkerModalComponent, OrganizationSelectorComponent],
                    exports: [PairWorkerModalComponent, OrganizationSelectorComponent],
                }]
        }] });

class ConfigurationDatasource extends NimmstaDataSource {
    constructor(configurationService, organizationService) {
        super(configurationService);
        this.configurationService = configurationService;
        this.organizationService = organizationService;
        this.forAdmin = false;
    }
    loadData(options) {
        const optionsCopy = { ...options };
        if (!this.forAdmin) {
            const params = new HttpParams().set('forceOrgSelection', 'true');
            if (!options) {
                return super.loadData({ additionalQueryParams: params });
            }
            if (!options.additionalQueryParams) {
                optionsCopy.additionalQueryParams = params;
            }
            else {
                optionsCopy.additionalQueryParams = options.additionalQueryParams.set('forceOrgSelection', 'true');
            }
            return super.loadData(optionsCopy);
        }
        return super.loadData(optionsCopy).pipe(switchMap(async (page) => {
            const orgIds = page.content.map((c) => c.organizationIds).flat();
            if (orgIds.length > 0) {
                await lastValueFrom(this.organizationService.getNameMap(orgIds));
            }
            return page;
        }));
    }
}

class OrganizationNameService extends OrganizationService {
    constructor() {
        super(...arguments);
        this.organizationsNameMap = {};
    }
    getNameMap(ids) {
        const orgIds = ids.filter((id) => !this.organizationsNameMap[id]).filter(this.unique);
        if (orgIds.length === 0) {
            return of(this.generateOrgMap(ids));
        }
        return this.http.get(this.baseUrl + this.apiEndpoint, {
            params: { unpaged: true, filters: this.buildOrgIdFilter(orgIds) },
        }).pipe(tap((page) => {
            page.content.forEach((org) => {
                this.organizationsNameMap[org.id] = org.name;
            });
        }), map(() => this.generateOrgMap(ids)));
    }
    buildOrgIdFilter(ids) {
        return ids.map((id) => `id:${id}-or`);
    }
    unique(value, index, self) {
        return self.indexOf(value) === index;
    }
    generateOrgMap(ids) {
        const orgMap = {};
        ids.forEach((id) => {
            orgMap[id] = this.organizationsNameMap[id] ?? '??';
        });
        return orgMap;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: OrganizationNameService, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: OrganizationNameService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: OrganizationNameService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class ConfigurationService extends ConfigurationDataService {
    updateOrganizationIds(configuration, organizationIds) {
        return this.http.put(`${this.baseUrl}/configurations/${configuration.id}/organizations`, organizationIds);
    }
    getConfigurationFile(id) {
        return this.http.get(`${this.baseUrl}/configurations/${id}/download`, { responseType: 'blob', observe: 'response' });
    }
    get apiEndpoint() {
        return '/configurations';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ConfigurationService, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ConfigurationService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ConfigurationService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class ConfigurationOrgFormComponent extends SaveableFormComponent {
    constructor(fb, statusBadge, organizationNameService, organizationService, configurationService) {
        super(configurationService);
        this.fb = fb;
        this.statusBadge = statusBadge;
        this.organizationNameService = organizationNameService;
        this.configurationService = configurationService;
        this.closeEvent = new EventEmitter();
        this.loadingEvent = new EventEmitter();
        this.customActions = [];
        this.selection = [];
        this.organizations = [];
        this.isModified = signal(false);
        this.setValue({});
        this.organizationSource = new NimmstaDataSource(organizationService);
    }
    get columns() {
        return [
            new Column('name', 'organizations.name', { sortable: true }),
            new Column('description', 'organizations.description', { sortable: true }),
            new Column('address', 'organizations.address', { sortable: true }),
            new Column('status', 'organizations.status', { pipe: this.statusBadge, sortable: true }),
        ];
    }
    select(orgId) {
        const org = this.organizationSource.data?.content.find((o) => o.id === orgId);
        if (org) {
            this.selection.push(org);
            this.calculateIsModified();
        }
    }
    remove(organization) {
        this.selection = this.selection.filter((o) => o.id !== organization.id);
        this.calculateIsModified();
    }
    calculateIsModified() {
        if (this.organizations.length !== this.selection.length) {
            this.isModified.set(true);
        }
        else {
            this.isModified.set(this.organizations.some((o) => !this.selection.find((s) => s.id === o.id)));
        }
    }
    save() {
        if (!this.isModified()) {
            this.closeEvent.emit();
            return;
        }
        this.configurationService.updateOrganizationIds(this.value, this.selection.map((o) => o.id)).subscribe({
            next: (configuration) => {
                this.setValue(configuration);
                this.closeEvent.emit();
            },
            error: (error) => {
                this.error = error;
            },
        });
    }
    setFormGroup() {
        this.form = this.fb.group({});
    }
    setValue(value) {
        super.setValue(value);
        if (value.organizationIds?.length) {
            this.organizationNameService.getNameMap(value.organizationIds).subscribe({
                next: (orgMap) => {
                    this.organizations = value.organizationIds.map((id) => ({ id, name: orgMap[id] }));
                    // Create copy of organizations to avoid reference issues
                    this.selection = this.organizations.slice();
                    this.isModified.set(false);
                },
                error: (error) => {
                    this.error = error;
                },
            });
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ConfigurationOrgFormComponent, deps: [{ token: i1$1.FormBuilder }, { token: i1.StatusBadgePipe }, { token: OrganizationNameService }, { token: i1.OrganizationService }, { token: ConfigurationService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: ConfigurationOrgFormComponent, selector: "app-configuration-org-form", outputs: { closeEvent: "closeEvent", loadingEvent: "loadingEvent" }, usesInheritance: true, ngImport: i0, template: "<form>\n  <div class=\"d-flex flex-row justify-content-between\">\n    <div>\n      <div *ngFor=\"let configuration of selection\">\n        {{ configuration.name }} <button class=\"btn btn-sm btn-danger\" (click)=\"remove(configuration)\">X</button>\n      </div>\n    </div>\n    <div>\n      <button class=\"btn btn-primary\" type=\"submit\" (click)=\"save()\" translate>save</button>\n    </div>\n  </div>\n\n  <app-datatable [dataSource]=\"organizationSource\"\n                 [columns]=\" columns\"\n                 [defaultPageSize]=\"10\"\n                 [actionNew]=\"false\"\n                 (showEvent)=\"select($event.valueOf())\">\n    <app-empty-table [icon]=\"'groups'\"\n                     [emptyText]=\"'organizations.empty_text' | translate\">\n    </app-empty-table>\n  </app-datatable>\n\n  <app-error [error]=\"error\"></app-error>\n</form>\n", dependencies: [{ kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.TranslateDirective, selector: "[translate],[ngx-translate]", inputs: ["translate", "translateParams"] }, { kind: "component", type: i1.DataTableComponent, selector: "app-datatable", inputs: ["dataSource", "columns", "identifier", "actionNew", "customActions", "iconActions", "btnClass", "customTableActions", "isMainTable", "loadOnInit", "searchEnabled", "showPagination", "defaultPageSize", "defaultSortName", "defaultSortDirection"], outputs: ["showEvent", "newEvent"] }, { kind: "component", type: i1.EmptyTableComponent, selector: "app-empty-table", inputs: ["icon", "emptyText", "buttonText"], outputs: ["btnClick"] }, { kind: "component", type: i1.ErrorComponent, selector: "app-error", inputs: ["error"] }, { kind: "directive", type: i1$1.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ConfigurationOrgFormComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-configuration-org-form', template: "<form>\n  <div class=\"d-flex flex-row justify-content-between\">\n    <div>\n      <div *ngFor=\"let configuration of selection\">\n        {{ configuration.name }} <button class=\"btn btn-sm btn-danger\" (click)=\"remove(configuration)\">X</button>\n      </div>\n    </div>\n    <div>\n      <button class=\"btn btn-primary\" type=\"submit\" (click)=\"save()\" translate>save</button>\n    </div>\n  </div>\n\n  <app-datatable [dataSource]=\"organizationSource\"\n                 [columns]=\" columns\"\n                 [defaultPageSize]=\"10\"\n                 [actionNew]=\"false\"\n                 (showEvent)=\"select($event.valueOf())\">\n    <app-empty-table [icon]=\"'groups'\"\n                     [emptyText]=\"'organizations.empty_text' | translate\">\n    </app-empty-table>\n  </app-datatable>\n\n  <app-error [error]=\"error\"></app-error>\n</form>\n" }]
        }], ctorParameters: () => [{ type: i1$1.FormBuilder }, { type: i1.StatusBadgePipe }, { type: OrganizationNameService }, { type: i1.OrganizationService }, { type: ConfigurationService }], propDecorators: { closeEvent: [{
                type: Output
            }], loadingEvent: [{
                type: Output
            }] } });

class ConfigurationDownloadFormComponent {
    constructor() {
        this.closeEvent = new EventEmitter();
        this.confirm = new EventEmitter();
    }
    confirmDownload() {
        if (this.configuration?.downloadLink) {
            window.open(this.configuration.downloadLink, '_blank');
        }
        this.ref?.hide();
    }
    close() {
        this.ref?.hide();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ConfigurationDownloadFormComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: ConfigurationDownloadFormComponent, selector: "app-configuration-download-form", inputs: { configuration: "configuration", ref: "ref" }, outputs: { closeEvent: "closeEvent", confirm: "confirm" }, ngImport: i0, template: "<div class=\"modal-header\">\n  <h4 class=\"modal-title\" translate>configurations.pendingTitle</h4>\n  <button type=\"button\" aria-label=\"Close\" class=\"btn-close\"></button>\n</div>\n<div class=\"modal-body\">\n  <div translate>configurations.pendingQuestion</div>\n</div>\n<div class=\"modal-footer\">\n  <button type=\"button\" class=\"btn btn-outline-secondary\" (click)=\"close()\" translate>cancel</button>\n  <button class=\"btn btn-primary\" type=\"submit\" (click)=\"confirmDownload()\" translate>download</button>\n</div>\n", dependencies: [{ kind: "directive", type: i2.TranslateDirective, selector: "[translate],[ngx-translate]", inputs: ["translate", "translateParams"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ConfigurationDownloadFormComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-configuration-download-form', template: "<div class=\"modal-header\">\n  <h4 class=\"modal-title\" translate>configurations.pendingTitle</h4>\n  <button type=\"button\" aria-label=\"Close\" class=\"btn-close\"></button>\n</div>\n<div class=\"modal-body\">\n  <div translate>configurations.pendingQuestion</div>\n</div>\n<div class=\"modal-footer\">\n  <button type=\"button\" class=\"btn btn-outline-secondary\" (click)=\"close()\" translate>cancel</button>\n  <button class=\"btn btn-primary\" type=\"submit\" (click)=\"confirmDownload()\" translate>download</button>\n</div>\n" }]
        }], propDecorators: { closeEvent: [{
                type: Output
            }], confirm: [{
                type: Output
            }], configuration: [{
                type: Input
            }], ref: [{
                type: Input
            }] } });

var State;
(function (State) {
    State["READY"] = "READY";
    State["SUBMITTED"] = "SUBMITTED";
})(State || (State = {}));

class ClearDownloadAction extends IconAction {
    constructor(isActive) {
        super('download', 'download', false, isActive);
    }
    isEnabled(configuration) {
        return of(configuration.state === State.READY);
    }
}

class PendingDownloadAction extends IconAction {
    constructor(isActive) {
        super('download', 'downloading', false, isActive);
    }
    isEnabled(configuration) {
        return of(configuration.state === State.SUBMITTED);
    }
}

var Platform;
(function (Platform) {
    Platform["ANDROID"] = "ANDROID";
    Platform["WINDOWS"] = "WINDOWS";
})(Platform || (Platform = {}));

class PlatformPipe {
    constructor(translateService) {
        this.translateService = translateService;
    }
    transform(value) {
        switch (value) {
            case Platform.ANDROID:
                return this.translateService.instant('configurations.platforms.android');
            case Platform.WINDOWS:
                return this.translateService.instant('configurations.platforms.windows');
        }
        return value;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PlatformPipe, deps: [{ token: i2.TranslateService }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: PlatformPipe, name: "platform" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PlatformPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'platform',
                }]
        }], ctorParameters: () => [{ type: i2.TranslateService }] });

class OrganizationNamePipe {
    constructor(organizationNameService) {
        this.organizationNameService = organizationNameService;
    }
    transform(value) {
        if (value === null || value === undefined) {
            return of('');
        }
        let ids = typeof value === 'string' ? [value] : value;
        if (!ids.length) {
            return of('');
        }
        ids = ids.map((id) => id.trim());
        return this.organizationNameService
            .getNameMap(ids)
            .pipe(map((orgMap) => ids.map((v) => orgMap[v]).join('<br>')));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: OrganizationNamePipe, deps: [{ token: OrganizationNameService }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: OrganizationNamePipe, name: "organizationName" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: OrganizationNamePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'organizationName' }]
        }], ctorParameters: () => [{ type: OrganizationNameService }] });

class ConfigStatePipe {
    constructor(translateService) {
        this.translateService = translateService;
    }
    transform(value) {
        switch (value) {
            case State.READY:
                return this.translateService.instant('configurations.stateValues.READY');
            case State.SUBMITTED:
                return this.translateService.instant('configurations.stateValues.SUBMITTED');
            default:
                return value;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ConfigStatePipe, deps: [{ token: i2.TranslateService }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: ConfigStatePipe, name: "configState" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ConfigStatePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'configState',
                }]
        }], ctorParameters: () => [{ type: i2.TranslateService }] });

class ConfigurationListComponent {
    get columns() {
        if (this.isAdmin()) {
            return [
                new Column('name', 'name', { sortable: true }),
                new Column('description', 'description'),
                new Column('organizationIds', 'organizations.title', { asyncPipe: this.organizationNamePipe }),
                new Column('createdAt', 'createdAt', { sortable: true, pipe: this.dateTimePipe }),
                new Column('lastUpdatedAt', 'lastUpdatedAt', { sortable: true, pipe: this.timeAgoPipe, invertSorting: true }),
                new Column('platform', 'configurations.platform', { sortable: true, pipe: this.platformPipe }),
                new Column('version', 'configurations.version', { sortable: true }),
                new Column('state', 'configurations.state', { sortable: true, pipe: this.configStatePipe }),
            ];
        }
        return [
            new Column('name', 'name', { sortable: true }),
            new Column('description', 'description'),
            new Column('createdAt', 'createdAt', { sortable: true, pipe: this.dateTimePipe }),
            new Column('lastUpdatedAt', 'lastUpdatedAt', { sortable: true, pipe: this.timeAgoPipe, invertSorting: true }),
            new Column('platform', 'configurations.platform', { sortable: true, pipe: this.platformPipe }),
            new Column('version', 'configurations.version', { sortable: true }),
            new Column('state', 'configurations.state', { sortable: true, pipe: this.configStatePipe }),
        ];
    }
    constructor(configurationService, dateTimePipe, timeAgoPipe, platformPipe, configuration, organizationService, translate, organizationNamePipe, configStatePipe, modalService) {
        this.configurationService = configurationService;
        this.dateTimePipe = dateTimePipe;
        this.timeAgoPipe = timeAgoPipe;
        this.platformPipe = platformPipe;
        this.configuration = configuration;
        this.organizationService = organizationService;
        this.translate = translate;
        this.organizationNamePipe = organizationNamePipe;
        this.configStatePipe = configStatePipe;
        this.modalService = modalService;
        this.isAdmin = input(true);
        this.iconActions = [];
        this.ServiceType = ServiceType;
        this.serviceType = this.configuration.serviceType;
    }
    ngOnInit() {
        this.source = new ConfigurationDatasource(this.configurationService, this.organizationService);
        this.source.forAdmin = this.isAdmin();
        const editAction = new IconAction('edit', 'edit');
        editAction.subscribe((id) => (this.edit(id)));
        this.iconActions.push(editAction);
        const initWithIdAction = new IconAction('configurations.initWithId', 'new_window');
        initWithIdAction.subscribe((id) => (this.initNewWithId(id)));
        this.iconActions.push(initWithIdAction);
        if (this.isAdmin()) {
            const orgAction = new IconAction('configurations.editOrgAccess', 'groups');
            orgAction.subscribe((id) => (this.editOrgs(id)));
            this.iconActions.push(orgAction);
        }
        const deleteAction = new IconAction('delete', 'delete', true);
        deleteAction.subscribe((id) => (this.delete(id)));
        this.iconActions.push(deleteAction);
        const clearDownloadAction = new ClearDownloadAction((id) => {
            const configuration = this.source.data?.content.find((c) => c.id === id);
            return !!configuration?.downloadLink;
        });
        clearDownloadAction.subscribe((id) => (this.download(id)));
        this.iconActions.push(clearDownloadAction);
        const pendingDownloadAction = new PendingDownloadAction((id) => {
            const configuration = this.source.data?.content.find((c) => c.id === id);
            return !!configuration?.downloadLink;
        });
        pendingDownloadAction.subscribe((id) => (this.initiatePendingDownload(id)));
        this.iconActions.push(pendingDownloadAction);
        if (this.isAdmin()) {
            const downloadConfigAction = new IconAction('configurations.downloadConfig', 'file_save');
            downloadConfigAction.subscribe((id) => (this.downloadConfig(id)));
            this.iconActions.push(downloadConfigAction);
        }
    }
    createNew() {
        const origin = this.isAdmin() ? 'management' : 'cloud';
        window.open(`${this.configuration.applicationUrls.configurations}`
            + `/v${this.configuration.defaultConfigurationVersion}?origin=${origin}`, '_self');
    }
    initNewWithId(id) {
        const configuration = this.source.data?.content.find((c) => c.id === id);
        if (!configuration) {
            return;
        }
        const origin = this.isAdmin() ? 'management' : 'cloud';
        window.open(`${this.configuration.applicationUrls.configurations}`
            + `/v${configuration.version}?origin=${origin}&platform=${configuration.platform.toLowerCase()}&initId=${id}`, '_self');
    }
    download(id) {
        const configuration = this.source.data?.content.find((c) => c.id === id);
        if (!configuration || !configuration.downloadLink) {
            return;
        }
        const link = configuration.downloadLink;
        window.open(link, '_blank');
    }
    downloadConfig(id) {
        this.configurationService.getConfigurationFile(id).subscribe({
            next: (response) => {
                const filename = response.headers.get('Content-Disposition')?.split('filename=')[1]
                    .replaceAll('"', '') ?? 'configuration.nimmstaconfig';
                const blob = response.body;
                if (!blob) {
                    throw new Error('No file data received');
                }
                const blobUrl = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = blobUrl;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(blobUrl);
            },
            error: (error) => { this.error = error; },
        });
    }
    initiatePendingDownload(id) {
        const configuration = this.source.data?.content.find((c) => c.id === id);
        if (!configuration) {
            return;
        }
        this.downloadModalRef = this.modalService.show(ConfigurationDownloadFormComponent);
        this.downloadModalRef.content.configuration = configuration;
        this.downloadModalRef.content.ref = this.downloadModalRef;
        this.downloadModalRef.onHide?.subscribe(() => {
            this.downloadModalRef = undefined;
        });
    }
    editOrgs(id) {
        if (!this.isAdmin()) {
            return;
        }
        this.translate.get('configurations.editOrgAccess').subscribe((value) => {
            this.openOrgModal(value, true, this.getSelectedObject(id));
        });
    }
    edit(id) {
        if (!this.source.data?.content.length) {
            return;
        }
        const element = this.source.data.content.find((c) => c.id === id);
        if (!element) {
            return;
        }
        const origin = this.isAdmin() ? 'management' : 'cloud';
        const url = `${this.configuration.applicationUrls.configurations}/v${element.version}`
            + `?id=${element.id}&platform=${element.platform.toLowerCase()}&origin=${origin}`;
        window.open(url, '_self');
    }
    delete(id) {
        const configuration = this.source.data?.content.find((c) => c.id === id);
        if (!configuration) {
            return;
        }
        this.configurationService.delete(configuration).subscribe({
            next: () => this.tableComponent.loadDataPage(),
            error: (error) => {
                this.error = error;
            },
        });
    }
    onSave() {
        this.editOrgFormComponent.onSave();
    }
    onModalClose() {
        if (!this.isAdmin()) {
            return;
        }
        this.editOrgModalComponent.hide();
        this.tableComponent.loadDataPage();
    }
    onLoading(loading) {
        this.editOrgModalComponent.loading = loading;
    }
    openOrgModal(title, editable, configuration) {
        this.editOrgFormComponent.editable = editable;
        this.editOrgFormComponent.setValue(configuration);
        this.editOrgModalComponent.title = title;
        this.editOrgModalComponent.editable = editable;
        this.editOrgModalComponent.show();
    }
    getSelectedObject(id) {
        return this.source.data?.content.filter((d) => id === d.id).pop();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ConfigurationListComponent, deps: [{ token: ConfigurationService }, { token: i1.DateTimePipe }, { token: i1.NimmstaTimeAgoPipe }, { token: PlatformPipe }, { token: i1.NimmstaCommonsModuleConfiguration }, { token: OrganizationNameService }, { token: i2.TranslateService }, { token: OrganizationNamePipe }, { token: ConfigStatePipe }, { token: i3$1.BsModalService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.1.0", version: "18.2.13", type: ConfigurationListComponent, selector: "app-configuration-list", inputs: { isAdmin: { classPropertyName: "isAdmin", publicName: "isAdmin", isSignal: true, isRequired: false, transformFunction: null } }, viewQueries: [{ propertyName: "tableComponent", first: true, predicate: DataTableComponent, descendants: true, static: true }, { propertyName: "editOrgModalComponent", first: true, predicate: ["EditOrgModal"], descendants: true, static: true }, { propertyName: "editOrgFormComponent", first: true, predicate: ConfigurationOrgFormComponent, descendants: true, static: true }], ngImport: i0, template: "<div class=\"box\">\n  <div class=\"box-row header\">\n    <app-header-bar [title]=\"'configurations.title'\" [showDefaultBackButton]=\"serviceType === ServiceType.CLOUD\"></app-header-bar>\n  </div>\n  <div class=\"content mt-2 mb-3\">\n    <div class=\"row\">\n      <app-datatable\n        [dataSource]=\"source\"\n        [columns]=\"columns\"\n        [iconActions]=\"iconActions\"\n        [identifier]=\"'configurations'\"\n        (newEvent)=\"createNew()\"\n      >\n        <app-empty-table\n          [emptyText]=\"'configurations.empty_text' | translate\"\n          [buttonText]=\"'configurations.create_new' | translate\"\n          (btnClick)=\"createNew()\"\n          [icon]=\"'manufacturing'\"\n        >\n        </app-empty-table>\n      </app-datatable>\n\n      <app-error [error]=\"error\"></app-error>\n\n      <app-model-modal #EditOrgModal (saveEvent)=\"onSave()\">\n        <app-configuration-org-form #form (closeEvent)=\"onModalClose()\" (loadingEvent)=\"onLoading($event.valueOf())\"></app-configuration-org-form>\n      </app-model-modal>\n    </div>\n  </div>\n</div>\n", dependencies: [{ kind: "component", type: i1.DataTableComponent, selector: "app-datatable", inputs: ["dataSource", "columns", "identifier", "actionNew", "customActions", "iconActions", "btnClass", "customTableActions", "isMainTable", "loadOnInit", "searchEnabled", "showPagination", "defaultPageSize", "defaultSortName", "defaultSortDirection"], outputs: ["showEvent", "newEvent"] }, { kind: "component", type: i1.AppModelModalComponent, selector: "app-model-modal", inputs: ["title", "editable", "loading", "shakeTime", "secondaryActionText", "secondaryActionEnabled"], outputs: ["saveEvent", "secondaryAction"] }, { kind: "component", type: i1.EmptyTableComponent, selector: "app-empty-table", inputs: ["icon", "emptyText", "buttonText"], outputs: ["btnClick"] }, { kind: "component", type: i1.HeaderBarComponent, selector: "app-header-bar", inputs: ["title", "backRoute", "showDefaultBackButton", "date"] }, { kind: "component", type: i1.ErrorComponent, selector: "app-error", inputs: ["error"] }, { kind: "component", type: ConfigurationOrgFormComponent, selector: "app-configuration-org-form", outputs: ["closeEvent", "loadingEvent"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ConfigurationListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-configuration-list', template: "<div class=\"box\">\n  <div class=\"box-row header\">\n    <app-header-bar [title]=\"'configurations.title'\" [showDefaultBackButton]=\"serviceType === ServiceType.CLOUD\"></app-header-bar>\n  </div>\n  <div class=\"content mt-2 mb-3\">\n    <div class=\"row\">\n      <app-datatable\n        [dataSource]=\"source\"\n        [columns]=\"columns\"\n        [iconActions]=\"iconActions\"\n        [identifier]=\"'configurations'\"\n        (newEvent)=\"createNew()\"\n      >\n        <app-empty-table\n          [emptyText]=\"'configurations.empty_text' | translate\"\n          [buttonText]=\"'configurations.create_new' | translate\"\n          (btnClick)=\"createNew()\"\n          [icon]=\"'manufacturing'\"\n        >\n        </app-empty-table>\n      </app-datatable>\n\n      <app-error [error]=\"error\"></app-error>\n\n      <app-model-modal #EditOrgModal (saveEvent)=\"onSave()\">\n        <app-configuration-org-form #form (closeEvent)=\"onModalClose()\" (loadingEvent)=\"onLoading($event.valueOf())\"></app-configuration-org-form>\n      </app-model-modal>\n    </div>\n  </div>\n</div>\n" }]
        }], ctorParameters: () => [{ type: ConfigurationService }, { type: i1.DateTimePipe }, { type: i1.NimmstaTimeAgoPipe }, { type: PlatformPipe }, { type: i1.NimmstaCommonsModuleConfiguration }, { type: OrganizationNameService }, { type: i2.TranslateService }, { type: OrganizationNamePipe }, { type: ConfigStatePipe }, { type: i3$1.BsModalService }], propDecorators: { tableComponent: [{
                type: ViewChild,
                args: [DataTableComponent, { static: true }]
            }], editOrgModalComponent: [{
                type: ViewChild,
                args: ['EditOrgModal', { static: true }]
            }], editOrgFormComponent: [{
                type: ViewChild,
                args: [ConfigurationOrgFormComponent, { static: true }]
            }] } });

class ConfigurationCustomerWrapperComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ConfigurationCustomerWrapperComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: ConfigurationCustomerWrapperComponent, selector: "ng-component", ngImport: i0, template: '<app-configuration-list [isAdmin]="false"></app-configuration-list>', isInline: true, dependencies: [{ kind: "component", type: ConfigurationListComponent, selector: "app-configuration-list", inputs: ["isAdmin"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ConfigurationCustomerWrapperComponent, decorators: [{
            type: Component,
            args: [{
                    template: '<app-configuration-list [isAdmin]="false"></app-configuration-list>',
                }]
        }] });

class UserFormComponent extends SaveableFormComponent {
    constructor(fb, userService, authService, modalService) {
        super(userService);
        this.fb = fb;
        this.userService = userService;
        this.authService = authService;
        this.modalService = modalService;
        this.closeEvent = new EventEmitter();
        this.loadingEvent = new EventEmitter();
        this.roles = Object.values(UserRole);
        this.setValue({});
    }
    setValue(value) {
        super.setValue(value);
        if (value.id) {
            this.form.controls['email'].disable();
        }
        else {
            this.form.controls['email'].enable();
        }
        this.authService.getCurrentUser().subscribe((user) => {
            if (this.editable && user.role === UserRole.ADMIN) {
                this.roles = [UserRole.ADMIN, UserRole.MANAGER];
            }
            else {
                this.value.role = UserRole.MANAGER;
                this.roles = [UserRole.MANAGER];
                this.form.controls['role'].setValue(UserRole.MANAGER);
            }
        });
    }
    static passwordRepeat(form) {
        const passwordControl = form.get('password');
        const passwordRepeatControl = form.get('repeat_password');
        const message = {
            not_matching: '',
        };
        if (passwordControl?.value !== passwordRepeatControl?.value && (form.value.id === 0 || passwordControl?.value !== '')) {
            passwordRepeatControl?.setErrors(message);
        }
        return null;
    }
    setFormGroup() {
        this.form = this.fb.group({
            id: this.value.id,
            email: [this.value.email, [Validators.required, Validators.email]],
            given_name: [this.value.given_name, [Validators.required, Validators.minLength(2), Validators.maxLength(30)]],
            family_name: [this.value.family_name, [Validators.required, Validators.minLength(2), Validators.maxLength(30)]],
            role: [this.value.role, [Validators.required]],
        });
        this.form.setValidators(UserFormComponent.passwordRepeat);
    }
    getValidators() {
        if (this.value.id === '') {
            return [Validators.required, Validators.minLength(8), Validators.maxLength(25)];
        }
        return [];
    }
    resetPasswordPrompt() {
        this.modalRef = this.modalService.show(this.resetModal);
    }
    resetPassword() {
        this.modalRef?.hide();
        this.userService.resetPassword(this.value).subscribe({
            error: (response) => {
                this.error = response;
            },
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: UserFormComponent, deps: [{ token: i1$1.FormBuilder }, { token: i1.UserService }, { token: i1.AuthService }, { token: i3$1.BsModalService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.13", type: UserFormComponent, selector: "app-user-form", outputs: { closeEvent: "closeEvent", loadingEvent: "loadingEvent" }, viewQueries: [{ propertyName: "resetModal", first: true, predicate: ["resetModal"], descendants: true, static: true }], usesInheritance: true, ngImport: i0, template: "<form [formGroup]=\"form\">\n  <div class=\"row\">\n    <div class=\"col-12 form-group\">\n      <label translate>user.email</label>\n      <app-input-with-error [control]=\"this.form.controls['email']\"></app-input-with-error>\n    </div>\n    <div class=\"col-12 form-group\">\n      <label translate>user.given_name</label>\n      <app-input-with-error [control]=\"this.form.controls['given_name']\"></app-input-with-error>\n    </div>\n    <div class=\"col-12 form-group\">\n      <label translate>user.family_name</label>\n      <app-input-with-error [control]=\"this.form.controls['family_name']\"></app-input-with-error>\n    </div>\n    @if (roles.length > 1) {\n      <div class=\"col-12 form-group\">\n        <label translate>user.role</label>\n        <app-input-with-error [control]=\"this.form.controls['role']\" [inputType]=\"'select'\" [selectValues]=\"roles\"></app-input-with-error>\n      </div>\n    }\n    @if (value.id) {\n      <div class=\"col-12 mt-2\">\n        <a (click)=\"resetPasswordPrompt()\" translate>user.reset_password?</a>\n      </div>\n    }\n  </div>\n  <app-error [error]=\"error\"></app-error>\n</form>\n\n<ng-template #resetModal>\n  <div class=\"modal-header\">\n    <h4 class=\"modal-title\" translate>user.reset_password?</h4>\n    <button type=\"button\" class=\"btn-close\" (click)=\"modalRef?.hide()\" aria-label=\"Close\"></button>\n  </div>\n  <div class=\"modal-body\">\n    <p translate>user.reset_question</p>\n  </div>\n  <div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-outline-primary\" (click)=\"modalRef?.hide()\" translate>cancel</button>\n    <button type=\"button\" class=\"btn btn-danger\" (click)=\"resetPassword()\" translate>user.reset_password</button>\n  </div>\n</ng-template>\n", dependencies: [{ kind: "directive", type: i1$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.TranslateDirective, selector: "[translate],[ngx-translate]", inputs: ["translate", "translateParams"] }, { kind: "component", type: i1.InputWithErrorComponent, selector: "app-input-with-error", inputs: ["control", "inputType", "selectValues", "selectNames", "type", "description", "selectDefaultText", "selectDefaultIsDisabled", "helpText", "prependIcon", "rows"], outputs: ["keyUpEvent"] }, { kind: "component", type: i1.ErrorComponent, selector: "app-error", inputs: ["error"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: UserFormComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-user-form', template: "<form [formGroup]=\"form\">\n  <div class=\"row\">\n    <div class=\"col-12 form-group\">\n      <label translate>user.email</label>\n      <app-input-with-error [control]=\"this.form.controls['email']\"></app-input-with-error>\n    </div>\n    <div class=\"col-12 form-group\">\n      <label translate>user.given_name</label>\n      <app-input-with-error [control]=\"this.form.controls['given_name']\"></app-input-with-error>\n    </div>\n    <div class=\"col-12 form-group\">\n      <label translate>user.family_name</label>\n      <app-input-with-error [control]=\"this.form.controls['family_name']\"></app-input-with-error>\n    </div>\n    @if (roles.length > 1) {\n      <div class=\"col-12 form-group\">\n        <label translate>user.role</label>\n        <app-input-with-error [control]=\"this.form.controls['role']\" [inputType]=\"'select'\" [selectValues]=\"roles\"></app-input-with-error>\n      </div>\n    }\n    @if (value.id) {\n      <div class=\"col-12 mt-2\">\n        <a (click)=\"resetPasswordPrompt()\" translate>user.reset_password?</a>\n      </div>\n    }\n  </div>\n  <app-error [error]=\"error\"></app-error>\n</form>\n\n<ng-template #resetModal>\n  <div class=\"modal-header\">\n    <h4 class=\"modal-title\" translate>user.reset_password?</h4>\n    <button type=\"button\" class=\"btn-close\" (click)=\"modalRef?.hide()\" aria-label=\"Close\"></button>\n  </div>\n  <div class=\"modal-body\">\n    <p translate>user.reset_question</p>\n  </div>\n  <div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-outline-primary\" (click)=\"modalRef?.hide()\" translate>cancel</button>\n    <button type=\"button\" class=\"btn btn-danger\" (click)=\"resetPassword()\" translate>user.reset_password</button>\n  </div>\n</ng-template>\n" }]
        }], ctorParameters: () => [{ type: i1$1.FormBuilder }, { type: i1.UserService }, { type: i1.AuthService }, { type: i3$1.BsModalService }], propDecorators: { closeEvent: [{
                type: Output
            }], loadingEvent: [{
                type: Output
            }], resetModal: [{
                type: ViewChild,
                args: ['resetModal', { static: true }]
            }] } });

class ImpersonateAction extends IconAction {
    constructor(_text, authService, _secondaryIcon) {
        super(_text, 'swap_horiz', false, undefined, _secondaryIcon);
        this.authService = authService;
    }
    isEnabled(user) {
        return this.authService.getCurrentUser().pipe(map((currentUser) => currentUser.email !== user.email
            && user.status === UserStatus.ACTIVE // only allow active users to be impersonated
            && sessionStorage.getItem(IMPERSONATION_SESSION_STORAGE_KEY) === null));
    }
}

class DeleteUserAction extends CustomAction {
    constructor(text, authService) {
        super(text, false, true);
        this.authService = authService;
    }
    isEnabled(item) {
        return this.authService.getCurrentUser().pipe(map((user) => user.role === UserRole.ADMIN || item.role !== UserRole.ADMIN));
    }
}

marker('user.unlock');
marker('user.lock');
class LockUnlockAction extends CustomAction {
    getText(item) {
        switch (item.status) {
            case UserStatus.INACTIVE:
                return 'user.unlock';
            default:
                return 'user.lock';
        }
    }
}

class OrganizationUserService extends WorkflowDataService {
    get apiEndpoint() {
        return '/user';
    }
    setOrgId(orgId) {
        this.orgId = orgId;
    }
    getOrgApiEndpoint() {
        return `/organization/${this.orgId}/user`;
    }
    list(options = {}) {
        const params = this.getParams(options);
        return this.http.get(this.baseUrl + this.getOrgApiEndpoint(), {
            params,
        });
    }
    create(user) {
        const createUser = {
            firstName: user.given_name,
            lastName: user.family_name,
            email: user.email,
            role: user.role,
        };
        return this.http.post(`${this.baseUrl + this.getOrgApiEndpoint()}`, createUser);
    }
    update(user) {
        const editUser = {
            firstName: user.given_name,
            lastName: user.family_name,
            email: user.email,
            organizationId: user.organization?.id,
            role: user.role,
        };
        return this.http.put(`${this.baseUrl + this.apiEndpoint}/${user.id}`, editUser);
    }
    lock(user) {
        return this.http.post(`${this.baseUrl + this.apiEndpoint}/${user.id}/lock`, {});
    }
    unlock(user) {
        return this.http.post(`${this.baseUrl + this.apiEndpoint}/${user.id}/unlock`, {});
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: OrganizationUserService, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: OrganizationUserService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: OrganizationUserService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class OrganizationUserComponent {
    constructor(orgService, userService, authService, translate, route, statusBadge, configuration) {
        this.orgService = orgService;
        this.userService = userService;
        this.authService = authService;
        this.translate = translate;
        this.route = route;
        this.statusBadge = statusBadge;
        this.configuration = configuration;
        this.customActions = [];
        this.iconActions = [];
    }
    get columns() {
        return [
            new Column('family_name', 'user.family_name', { sortable: true }),
            new Column('given_name', 'user.given_name', { sortable: true }),
            new Column('email', 'user.email', { sortable: true }),
            new Column('role', 'user.role', { translate: true }),
            new Column('status', 'user.status', { sortable: true, pipe: this.statusBadge }),
        ];
    }
    ngOnInit() {
        const orgId = this.route.snapshot.paramMap.get('id');
        if (!orgId) {
            throw new Error('Organization id is required');
        }
        this.orgId = orgId;
        this.orgService.get(this.orgId).subscribe((org) => {
            this.title = org.name;
        });
        this.userService.setOrgId(this.orgId);
        this.userSource = new NimmstaDataSource(this.userService);
        if (this.configuration.applicationUrls.workflow) {
            const impersonateAction = new ImpersonateAction('Impersonate on Productivity Cloud', this.authService, 'cloud');
            impersonateAction.subscribe((id) => this.impersonate(id, new URL(this.configuration.applicationUrls.workflow)));
            this.iconActions.push(impersonateAction);
        }
        const editAction = new CustomAction('edit');
        editAction.subscribe((id) => this.edit(id));
        this.customActions.push(editAction);
        const deleteAction = new DeleteUserAction('delete', this.authService);
        deleteAction.subscribe((id) => this.delete(id));
        this.customActions.push(deleteAction);
        const lockUnlockAction = new LockUnlockAction('user.unlock');
        this.customActions.push(lockUnlockAction);
        lockUnlockAction.subscribe((id) => this.toggleLock(id));
    }
    new() {
        this.translate.get('user.new').subscribe((value) => {
            const user = {};
            user.organizationId = this.orgId;
            this.openModal(value, true, user);
        });
    }
    impersonate(id, target) {
        this.userSource.data?.content.filter((d) => id === d.id).forEach((user) => {
            this.authService.impersonate(user.email).subscribe({
                next: (data) => {
                    const error = launchImpersonationInNewTab(this.authService, data, target);
                    if (error) {
                        this.error = new HttpErrorResponse({
                            error: { error: error.message },
                        });
                    }
                },
                error: (error) => {
                    this.error = new HttpErrorResponse({
                        ...error,
                        error: { ...error.error, error: `httperror.${error.status}` },
                    });
                },
            });
        });
    }
    edit(id) {
        this.translate.get('user.edit').subscribe((value) => {
            this.openModal(value, true, this.getSelectedObject(id));
        });
    }
    openModal(title, editable, user) {
        this.userFormComponent.editable = editable;
        this.userFormComponent.setValue(user);
        this.editModalComponent.title = title;
        this.editModalComponent.editable = editable;
        const modalRef = this.editModalComponent.show();
        modalRef.setClass('modal-sm');
    }
    delete(id) {
        lastValueFrom(this.userService.delete(this.getSelectedObject(id))).then(() => this.tableComponent.loadDataPage());
    }
    toggleLock(id) {
        const user = this.getSelectedObject(id);
        if (user.status === UserStatus.ACTIVE) {
            this.lock(id);
        }
        else {
            this.unlock(id);
        }
    }
    lock(id) {
        lastValueFrom(this.userService.lock(this.getSelectedObject(id))).then(() => this.tableComponent.loadDataPage());
    }
    unlock(id) {
        lastValueFrom(this.userService.unlock(this.getSelectedObject(id))).then(() => this.tableComponent.loadDataPage());
    }
    onSave() {
        this.userFormComponent.onSave();
    }
    onModalClose() {
        this.editModalComponent.hide();
        this.tableComponent.loadDataPage();
    }
    getSelectedObject(id) {
        return this.userSource.data?.content.filter((d) => id === d.id).pop();
    }
    onLoading(loading) {
        this.editModalComponent.loading = loading;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: OrganizationUserComponent, deps: [{ token: i1.OrganizationService }, { token: OrganizationUserService }, { token: i1.AuthService }, { token: i2.TranslateService }, { token: i1$2.ActivatedRoute }, { token: i1.StatusBadgePipe }, { token: i1.NimmstaCommonsModuleConfiguration }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: OrganizationUserComponent, selector: "app-organization-user", viewQueries: [{ propertyName: "tableComponent", first: true, predicate: DataTableComponent, descendants: true, static: true }, { propertyName: "editModalComponent", first: true, predicate: ["EditModal"], descendants: true }, { propertyName: "userFormComponent", first: true, predicate: UserFormComponent, descendants: true, static: true }], ngImport: i0, template: "<div class=\"box\">\n  <div class=\"box-row header\">\n    <app-header-bar [backRoute]=\"'/organizations'\" [title]=\"title || 'organizations.title'\"></app-header-bar>\n  </div>\n  <div class=\"content mt-2 mb-3\">\n    <div class=\"row\">\n      <app-datatable [dataSource]=\"userSource\"\n              [columns]=\"columns\"\n              [identifier]=\"'org-users'\"\n              [customActions]=\"customActions\"\n              [iconActions]=\"iconActions\"\n              (newEvent)=\"new()\"\n              (showEvent)=\"edit($event.valueOf())\">\n                <app-empty-table [icon]=\"'person'\"\n                  [emptyText]=\"'user.empty_text' | translate\"\n                  [buttonText]=\"'createNew' | translate\"\n                  (btnClick)=\"new()\">\n                </app-empty-table>\n      </app-datatable>\n\n      <app-error [error]=\"error\"></app-error>\n\n      <app-model-modal #EditModal (saveEvent)=\"onSave()\">\n        <app-user-form #form (closeEvent)=\"onModalClose()\" (loadingEvent)=\"onLoading($event.valueOf())\"></app-user-form>\n      </app-model-modal>\n    </div>\n  </div>\n</div>\n", dependencies: [{ kind: "component", type: i1.DataTableComponent, selector: "app-datatable", inputs: ["dataSource", "columns", "identifier", "actionNew", "customActions", "iconActions", "btnClass", "customTableActions", "isMainTable", "loadOnInit", "searchEnabled", "showPagination", "defaultPageSize", "defaultSortName", "defaultSortDirection"], outputs: ["showEvent", "newEvent"] }, { kind: "component", type: i1.AppModelModalComponent, selector: "app-model-modal", inputs: ["title", "editable", "loading", "shakeTime", "secondaryActionText", "secondaryActionEnabled"], outputs: ["saveEvent", "secondaryAction"] }, { kind: "component", type: i1.EmptyTableComponent, selector: "app-empty-table", inputs: ["icon", "emptyText", "buttonText"], outputs: ["btnClick"] }, { kind: "component", type: i1.HeaderBarComponent, selector: "app-header-bar", inputs: ["title", "backRoute", "showDefaultBackButton", "date"] }, { kind: "component", type: i1.ErrorComponent, selector: "app-error", inputs: ["error"] }, { kind: "component", type: UserFormComponent, selector: "app-user-form", outputs: ["closeEvent", "loadingEvent"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: OrganizationUserComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-organization-user', template: "<div class=\"box\">\n  <div class=\"box-row header\">\n    <app-header-bar [backRoute]=\"'/organizations'\" [title]=\"title || 'organizations.title'\"></app-header-bar>\n  </div>\n  <div class=\"content mt-2 mb-3\">\n    <div class=\"row\">\n      <app-datatable [dataSource]=\"userSource\"\n              [columns]=\"columns\"\n              [identifier]=\"'org-users'\"\n              [customActions]=\"customActions\"\n              [iconActions]=\"iconActions\"\n              (newEvent)=\"new()\"\n              (showEvent)=\"edit($event.valueOf())\">\n                <app-empty-table [icon]=\"'person'\"\n                  [emptyText]=\"'user.empty_text' | translate\"\n                  [buttonText]=\"'createNew' | translate\"\n                  (btnClick)=\"new()\">\n                </app-empty-table>\n      </app-datatable>\n\n      <app-error [error]=\"error\"></app-error>\n\n      <app-model-modal #EditModal (saveEvent)=\"onSave()\">\n        <app-user-form #form (closeEvent)=\"onModalClose()\" (loadingEvent)=\"onLoading($event.valueOf())\"></app-user-form>\n      </app-model-modal>\n    </div>\n  </div>\n</div>\n" }]
        }], ctorParameters: () => [{ type: i1.OrganizationService }, { type: OrganizationUserService }, { type: i1.AuthService }, { type: i2.TranslateService }, { type: i1$2.ActivatedRoute }, { type: i1.StatusBadgePipe }, { type: i1.NimmstaCommonsModuleConfiguration }], propDecorators: { tableComponent: [{
                type: ViewChild,
                args: [DataTableComponent, { static: true }]
            }], editModalComponent: [{
                type: ViewChild,
                args: ['EditModal', { static: false }]
            }], userFormComponent: [{
                type: ViewChild,
                args: [UserFormComponent, { static: true }]
            }] } });

class OrganizationFormComponent extends SaveableFormComponent {
    constructor(fb, organizationService) {
        super(organizationService);
        this.fb = fb;
        this.closeEvent = new EventEmitter();
        this.loadingEvent = new EventEmitter();
        this.status = Object.values(OrganizationStatus);
        this.types = Object.values(OrganizationType);
        this.showOrganizationSelection = false;
        this.OrganizationType = OrganizationType;
        this.setValue(new Organization());
    }
    setFormGroup() {
        this.form = this.fb.group({
            id: this.value.id,
            name: [this.value.name, [Validators.required]],
            address: [this.value.address, []],
            description: [this.value.description, []],
            status: [this.value.status, [Validators.required]],
            type: [this.value.type, [Validators.required]],
        });
    }
    applyCustomValues() {
        super.applyCustomValues();
        const canHaveParent = this.value.type === OrganizationType.CUSTOMER;
        this.value = {
            ...this.value,
            parentOrganization: undefined,
            parentOrganizationId: canHaveParent ? this.parentOrganization?.id : undefined,
        };
    }
    setValue(value) {
        super.setValue(value);
        this.showOrganizationSelection = false;
        if (value.parentOrganization) {
            this.parentOrganization = value.parentOrganization;
        }
        else {
            this.parentOrganization = undefined;
        }
    }
    selectOrg(org) {
        this.form.patchValue({
            recipientCompanyId: org.id,
        });
        this.form.markAsDirty();
        this.parentOrganization = org;
        this.showOrganizationSelection = false;
    }
    removeOrg() {
        this.form.patchValue({
            recipientCompanyId: null,
        });
        this.form.markAsDirty();
        this.parentOrganization = undefined;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: OrganizationFormComponent, deps: [{ token: i1$1.FormBuilder }, { token: i1.OrganizationService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: OrganizationFormComponent, selector: "app-organization-form", outputs: { closeEvent: "closeEvent", loadingEvent: "loadingEvent" }, usesInheritance: true, ngImport: i0, template: "<form [formGroup]=\"form\">\n  <div class=\"row\">\n    <div class=\"col-md-6 form-group\">\n      <label translate>organizations.name</label>\n      <app-input-with-error [control]=\"this.form.controls['name']\"></app-input-with-error>\n    </div>\n    <div class=\"col-md-6 form-group\">\n      <label translate>organizations.address</label>\n      <app-input-with-error [control]=\"this.form.controls['address']\"></app-input-with-error>\n    </div>\n    <div class=\"col-md-6 form-group\">\n      <label translate>organizations.description</label>\n      <app-input-with-error [control]=\"this.form.controls['description']\"></app-input-with-error>\n    </div>\n    <div class=\"col-md-6 form-group\">\n      <label translate>organizations.status</label>\n      <app-input-with-error [control]=\"this.form.controls['status']\" [inputType]=\"'select'\" [selectValues]=\"status\"></app-input-with-error>\n    </div>\n    <div class=\"col-md-6 form-group\">\n      <label translate>organizations.type</label>\n      <app-input-with-error [control]=\"this.form.controls['type']\" [inputType]=\"'select'\" [selectValues]=\"types\"></app-input-with-error>\n    </div>\n\n    <div class=\"col-md-6 form-group\" *ngIf=\"this.form.controls['type'].value === OrganizationType.CUSTOMER\">\n      <label translate>organizations.parentOrganization</label>\n      <div class=\"input-group\">\n        <input type=\"text\" class=\"form-control\" [value]=\"parentOrganization?.name\" [disabled]=\"true\">\n        <button class=\"btn btn-primary\" (click)=\"showOrganizationSelection = true\" translate [disabled]=\"showOrganizationSelection\">select</button>\n        <button *ngIf=\"parentOrganization\" class=\"btn btn-danger\" (click)=\"removeOrg()\" translate>clear</button>\n      </div>\n    </div>\n  </div>\n  <app-error [error]=\"error\"></app-error>\n</form>\n\n<app-organization-selector *ngIf=\"showOrganizationSelection\" [type]=\"OrganizationType.PARTNER\" (orgSelected)=\"selectOrg($event)\"></app-organization-selector>\n", dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.TranslateDirective, selector: "[translate],[ngx-translate]", inputs: ["translate", "translateParams"] }, { kind: "component", type: i1.InputWithErrorComponent, selector: "app-input-with-error", inputs: ["control", "inputType", "selectValues", "selectNames", "type", "description", "selectDefaultText", "selectDefaultIsDisabled", "helpText", "prependIcon", "rows"], outputs: ["keyUpEvent"] }, { kind: "component", type: i1.ErrorComponent, selector: "app-error", inputs: ["error"] }, { kind: "component", type: OrganizationSelectorComponent, selector: "app-organization-selector", inputs: ["type"], outputs: ["orgSelected"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: OrganizationFormComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-organization-form', template: "<form [formGroup]=\"form\">\n  <div class=\"row\">\n    <div class=\"col-md-6 form-group\">\n      <label translate>organizations.name</label>\n      <app-input-with-error [control]=\"this.form.controls['name']\"></app-input-with-error>\n    </div>\n    <div class=\"col-md-6 form-group\">\n      <label translate>organizations.address</label>\n      <app-input-with-error [control]=\"this.form.controls['address']\"></app-input-with-error>\n    </div>\n    <div class=\"col-md-6 form-group\">\n      <label translate>organizations.description</label>\n      <app-input-with-error [control]=\"this.form.controls['description']\"></app-input-with-error>\n    </div>\n    <div class=\"col-md-6 form-group\">\n      <label translate>organizations.status</label>\n      <app-input-with-error [control]=\"this.form.controls['status']\" [inputType]=\"'select'\" [selectValues]=\"status\"></app-input-with-error>\n    </div>\n    <div class=\"col-md-6 form-group\">\n      <label translate>organizations.type</label>\n      <app-input-with-error [control]=\"this.form.controls['type']\" [inputType]=\"'select'\" [selectValues]=\"types\"></app-input-with-error>\n    </div>\n\n    <div class=\"col-md-6 form-group\" *ngIf=\"this.form.controls['type'].value === OrganizationType.CUSTOMER\">\n      <label translate>organizations.parentOrganization</label>\n      <div class=\"input-group\">\n        <input type=\"text\" class=\"form-control\" [value]=\"parentOrganization?.name\" [disabled]=\"true\">\n        <button class=\"btn btn-primary\" (click)=\"showOrganizationSelection = true\" translate [disabled]=\"showOrganizationSelection\">select</button>\n        <button *ngIf=\"parentOrganization\" class=\"btn btn-danger\" (click)=\"removeOrg()\" translate>clear</button>\n      </div>\n    </div>\n  </div>\n  <app-error [error]=\"error\"></app-error>\n</form>\n\n<app-organization-selector *ngIf=\"showOrganizationSelection\" [type]=\"OrganizationType.PARTNER\" (orgSelected)=\"selectOrg($event)\"></app-organization-selector>\n" }]
        }], ctorParameters: () => [{ type: i1$1.FormBuilder }, { type: i1.OrganizationService }], propDecorators: { closeEvent: [{
                type: Output
            }], loadingEvent: [{
                type: Output
            }] } });

marker('organizations.approve');
marker('organizations.decline');
class ApproveDeclineAction extends CustomAction {
    getText(item) {
        switch (item.status) {
            case OrganizationStatus.INACTIVE:
                return 'organizations.approve';
            default:
                return 'organizations.decline';
        }
    }
}

class OrganizationsComponent {
    get columns() {
        return [
            new Column('name', 'organizations.name', { sortable: true }),
            new Column('description', 'organizations.description', { sortable: true }),
            new Column('address', 'organizations.address', { sortable: true }),
            new Column('type', 'organizations.type', { sortable: true, pipe: this.organizationTypePipe }),
            new Column('parentOrganization.name', 'organizations.parentOrganization', { sortable: true, sortingName: 'parentOrganization.name' }),
            new Column('status', 'organizations.status', { pipe: this.statusBadge, sortable: true }),
            new Column('createdAt', 'createdAt', { pipe: this.dateTimePipe, sortable: true }),
        ];
    }
    constructor(organizationService, translate, statusBadge, router, route, organizationTypePipe, dateTimePipe) {
        this.organizationService = organizationService;
        this.translate = translate;
        this.statusBadge = statusBadge;
        this.router = router;
        this.route = route;
        this.organizationTypePipe = organizationTypePipe;
        this.dateTimePipe = dateTimePipe;
        this.customActions = [];
    }
    ngOnInit() {
        this.organizationSource = new NimmstaDataSource(this.organizationService);
        const approveDeclineAction = new ApproveDeclineAction('organizations.approve');
        this.customActions.push(approveDeclineAction);
        approveDeclineAction.subscribe((id) => this.approveDecline(id));
        const editAction = new CustomAction('edit');
        this.customActions.push(editAction);
        editAction.subscribe((id) => this.edit(id));
        const deleteAction = new CustomAction('delete', false, true);
        this.customActions.push(deleteAction);
        deleteAction.subscribe((id) => this.delete(id));
    }
    approveDecline(id) {
        const org = this.getSelectedObject(id);
        if (org.status === OrganizationStatus.ACTIVE) {
            this.decline(org);
        }
        else {
            this.approve(org);
        }
    }
    approve(org) {
        this.toggleStatus(org, OrganizationStatus.ACTIVE);
    }
    decline(org) {
        this.toggleStatus(org, OrganizationStatus.INACTIVE);
    }
    toggleStatus(org, status) {
        // eslint-disable-next-line no-param-reassign
        org.status = status;
        this.organizationService.createOrUpdate(org).subscribe({
            next: () => {
                this.tableComponent.loadDataPage();
            },
            error: (error) => {
                this.error = error;
            },
        });
    }
    new() {
        this.translate.get('organizations.new').subscribe((value) => {
            this.openModal(value, true, new Organization());
        });
    }
    edit(id) {
        this.translate.get('organizations.edit').subscribe((value) => {
            this.openModal(value, true, this.getSelectedObject(id));
        });
    }
    delete(id) {
        this.organizationService.delete(this.getSelectedObject(id)).subscribe({
            next: () => {
                this.tableComponent.loadDataPage();
            },
            error: (error) => {
                this.error = error;
            },
        });
    }
    show(id) {
        this.router.navigate([id], { relativeTo: this.route });
    }
    getSelectedObject(id) {
        return this.organizationSource.data?.content.filter((d) => id === d.id).pop();
    }
    onSave() {
        this.orgFormComponent.onSave();
    }
    onModalClose() {
        this.editModalComponent.hide();
        this.tableComponent.loadDataPage();
    }
    onLoading(loading) {
        this.editModalComponent.loading = loading;
    }
    openModal(title, editable, organization) {
        this.orgFormComponent.editable = editable;
        this.orgFormComponent.setValue(organization);
        this.editModalComponent.title = title;
        this.editModalComponent.editable = editable;
        this.editModalComponent.show();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: OrganizationsComponent, deps: [{ token: i1.OrganizationService }, { token: i2.TranslateService }, { token: i1.StatusBadgePipe }, { token: i1$2.Router }, { token: i1$2.ActivatedRoute }, { token: OrganizationTypePipe }, { token: i1.DateTimePipe }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: OrganizationsComponent, selector: "app-organizations", viewQueries: [{ propertyName: "tableComponent", first: true, predicate: DataTableComponent, descendants: true, static: true }, { propertyName: "editModalComponent", first: true, predicate: ["EditModal"], descendants: true, static: true }, { propertyName: "orgFormComponent", first: true, predicate: OrganizationFormComponent, descendants: true, static: true }], ngImport: i0, template: "<div class=\"box\">\n  <div class=\"box-row header\">\n    <app-header-bar [title]=\"'organizations.title'\"></app-header-bar>\n  </div>\n  <div class=\"content mt-2 mb-3\">\n    <div class=\"row\">\n      <app-datatable [dataSource]=\"organizationSource\"\n                    [columns]=\" columns\"\n                    [customActions]=\"customActions\"\n                    [identifier]=\"'organizations'\"\n                    (newEvent)=\"new()\"\n                    (showEvent)=\"show($event.valueOf())\">\n        <app-empty-table [icon]=\"'groups'\"\n                        [emptyText]=\"'organizations.empty_text' | translate\"\n                        [buttonText]=\"'createNew' | translate\"\n        (btnClick)=\"new()\">\n        </app-empty-table>\n      </app-datatable>\n\n      <app-error [error]=\"error\"></app-error>\n\n      <app-model-modal #EditModal (saveEvent)=\"onSave()\">\n        <app-organization-form #form (closeEvent)=\"onModalClose()\" (loadingEvent)=\"onLoading($event.valueOf())\"></app-organization-form>\n      </app-model-modal>\n    </div>\n  </div>\n</div>\n", dependencies: [{ kind: "component", type: i1.DataTableComponent, selector: "app-datatable", inputs: ["dataSource", "columns", "identifier", "actionNew", "customActions", "iconActions", "btnClass", "customTableActions", "isMainTable", "loadOnInit", "searchEnabled", "showPagination", "defaultPageSize", "defaultSortName", "defaultSortDirection"], outputs: ["showEvent", "newEvent"] }, { kind: "component", type: i1.AppModelModalComponent, selector: "app-model-modal", inputs: ["title", "editable", "loading", "shakeTime", "secondaryActionText", "secondaryActionEnabled"], outputs: ["saveEvent", "secondaryAction"] }, { kind: "component", type: i1.EmptyTableComponent, selector: "app-empty-table", inputs: ["icon", "emptyText", "buttonText"], outputs: ["btnClick"] }, { kind: "component", type: i1.HeaderBarComponent, selector: "app-header-bar", inputs: ["title", "backRoute", "showDefaultBackButton", "date"] }, { kind: "component", type: i1.ErrorComponent, selector: "app-error", inputs: ["error"] }, { kind: "component", type: OrganizationFormComponent, selector: "app-organization-form", outputs: ["closeEvent", "loadingEvent"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: OrganizationsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-organizations', template: "<div class=\"box\">\n  <div class=\"box-row header\">\n    <app-header-bar [title]=\"'organizations.title'\"></app-header-bar>\n  </div>\n  <div class=\"content mt-2 mb-3\">\n    <div class=\"row\">\n      <app-datatable [dataSource]=\"organizationSource\"\n                    [columns]=\" columns\"\n                    [customActions]=\"customActions\"\n                    [identifier]=\"'organizations'\"\n                    (newEvent)=\"new()\"\n                    (showEvent)=\"show($event.valueOf())\">\n        <app-empty-table [icon]=\"'groups'\"\n                        [emptyText]=\"'organizations.empty_text' | translate\"\n                        [buttonText]=\"'createNew' | translate\"\n        (btnClick)=\"new()\">\n        </app-empty-table>\n      </app-datatable>\n\n      <app-error [error]=\"error\"></app-error>\n\n      <app-model-modal #EditModal (saveEvent)=\"onSave()\">\n        <app-organization-form #form (closeEvent)=\"onModalClose()\" (loadingEvent)=\"onLoading($event.valueOf())\"></app-organization-form>\n      </app-model-modal>\n    </div>\n  </div>\n</div>\n" }]
        }], ctorParameters: () => [{ type: i1.OrganizationService }, { type: i2.TranslateService }, { type: i1.StatusBadgePipe }, { type: i1$2.Router }, { type: i1$2.ActivatedRoute }, { type: OrganizationTypePipe }, { type: i1.DateTimePipe }], propDecorators: { tableComponent: [{
                type: ViewChild,
                args: [DataTableComponent, { static: true }]
            }], editModalComponent: [{
                type: ViewChild,
                args: ['EditModal', { static: true }]
            }], orgFormComponent: [{
                type: ViewChild,
                args: [OrganizationFormComponent, { static: true }]
            }] } });

class OrganizationSettingsComponent {
    constructor(authService, orgService, userService) {
        this.authService = authService;
        this.orgService = orgService;
        this.userService = userService;
        this.form = new FormGroup({
            name: new FormControl('', Validators.required),
            owner: new FormControl(null),
        });
        this.loading = false;
        this.changed = signal(false);
        this.users = [];
    }
    ngOnInit() {
        this.authService.getCurrentUser().subscribe({
            next: (user) => {
                this.organization = user.organization;
                this.form.patchValue(this.organization);
                this.loading = false;
                this.userService.setOrgId(this.organization.id);
                if (user.role !== UserRole.ADMIN && this.organization.owner && this.organization.owner.id !== user.id) {
                    this.form.controls.owner.disable();
                }
                this.userService.list({
                    filter: null,
                    sortColumn: 'family_name',
                    pageSize: 9999,
                }).subscribe((users) => {
                    this.users = users.content;
                });
            },
            error: (error) => {
                this.error = error;
                this.loading = false;
            },
        });
        this.form.valueChanges.subscribe(() => {
            if (this.form.value.name !== this.organization.name || this.form.value.owner?.id !== this.organization.owner?.id) {
                this.changed.set(true);
            }
            else {
                this.changed.set(false);
            }
        });
    }
    save() {
        this.loading = true;
        const orgUpdate = {
            ...this.organization,
            name: this.form.get('name').value,
            ownerId: this.form.get('owner').value?.id,
        };
        this.orgService.update(orgUpdate).subscribe({
            next: () => {
                this.authService.loadCurrentUser().subscribe();
            },
            error: (error) => {
                this.error = error;
                this.loading = false;
            },
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: OrganizationSettingsComponent, deps: [{ token: i1.AuthService }, { token: i1.OrganizationService }, { token: OrganizationUserService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: OrganizationSettingsComponent, selector: "app-organization-settings", ngImport: i0, template: "<div class=\"box\">\n  <div class=\"box-row header\">\n    <app-header-bar [title]=\"'organization'\"></app-header-bar>\n  </div>\n  <div class=\"content mt-2 mb-3\">\n    <form [formGroup]=\"form\">\n      <div class=\"col-md-3\">\n        <div class=\"row form-group\">\n          <label translate>organizations.name</label>\n          <app-input-with-error [control]=\"this.form.controls['name']\"></app-input-with-error>\n        </div>\n        <div class=\"row form-group\">\n          <label translate>organizations.owner</label>\n          <div>\n          <p-dropdown [options]=\"users\" dataKey=\"id\" formControlName=\"owner\" [placeholder]=\"'organizations.chooseOwner' | translate\">\n            <ng-template let-item pTemplate=\"selectedItem\">\n              <div>{{item.given_name + ' ' + item.family_name}}</div>\n            </ng-template>\n            <ng-template let-item pTemplate=\"item\">\n              <div>{{item.given_name + ' ' + item.family_name}}</div>\n            </ng-template>\n          </p-dropdown>\n          </div>\n        </div>\n\n        <div class=\"d-flex justify-content-end mt-3\">\n          <button [disabled]=\"!form.valid || !changed()\" type=\"button\" class=\"btn btn-secondary\" (click)=\"save()\" [ladda]=\"loading\"\n                  translate=\"save\"></button>\n        </div>\n      </div>\n    </form>\n    <app-error [error]=\"error\"></app-error>\n  </div>\n</div>\n", dependencies: [{ kind: "directive", type: i1$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "directive", type: i5.LaddaDirective, selector: "[ladda]", inputs: ["ladda", "disabled"] }, { kind: "directive", type: i2.TranslateDirective, selector: "[translate],[ngx-translate]", inputs: ["translate", "translateParams"] }, { kind: "component", type: i1.InputWithErrorComponent, selector: "app-input-with-error", inputs: ["control", "inputType", "selectValues", "selectNames", "type", "description", "selectDefaultText", "selectDefaultIsDisabled", "helpText", "prependIcon", "rows"], outputs: ["keyUpEvent"] }, { kind: "component", type: i1.HeaderBarComponent, selector: "app-header-bar", inputs: ["title", "backRoute", "showDefaultBackButton", "date"] }, { kind: "component", type: i1.ErrorComponent, selector: "app-error", inputs: ["error"] }, { kind: "component", type: i6.Dropdown, selector: "p-dropdown", inputs: ["id", "scrollHeight", "filter", "name", "style", "panelStyle", "styleClass", "panelStyleClass", "readonly", "required", "editable", "appendTo", "tabindex", "placeholder", "loadingIcon", "filterPlaceholder", "filterLocale", "variant", "inputId", "dataKey", "filterBy", "filterFields", "autofocus", "resetFilterOnHide", "checkmark", "dropdownIcon", "loading", "optionLabel", "optionValue", "optionDisabled", "optionGroupLabel", "optionGroupChildren", "autoDisplayFirst", "group", "showClear", "emptyFilterMessage", "emptyMessage", "lazy", "virtualScroll", "virtualScrollItemSize", "virtualScrollOptions", "overlayOptions", "ariaFilterLabel", "ariaLabel", "ariaLabelledBy", "filterMatchMode", "maxlength", "tooltip", "tooltipPosition", "tooltipPositionStyle", "tooltipStyleClass", "focusOnHover", "selectOnFocus", "autoOptionFocus", "autofocusFilter", "fluid", "disabled", "itemSize", "autoZIndex", "baseZIndex", "showTransitionOptions", "hideTransitionOptions", "filterValue", "options"], outputs: ["onChange", "onFilter", "onFocus", "onBlur", "onClick", "onShow", "onHide", "onClear", "onLazyLoad"] }, { kind: "directive", type: i7$1.PrimeTemplate, selector: "[pTemplate]", inputs: ["type", "pTemplate"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: OrganizationSettingsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-organization-settings', template: "<div class=\"box\">\n  <div class=\"box-row header\">\n    <app-header-bar [title]=\"'organization'\"></app-header-bar>\n  </div>\n  <div class=\"content mt-2 mb-3\">\n    <form [formGroup]=\"form\">\n      <div class=\"col-md-3\">\n        <div class=\"row form-group\">\n          <label translate>organizations.name</label>\n          <app-input-with-error [control]=\"this.form.controls['name']\"></app-input-with-error>\n        </div>\n        <div class=\"row form-group\">\n          <label translate>organizations.owner</label>\n          <div>\n          <p-dropdown [options]=\"users\" dataKey=\"id\" formControlName=\"owner\" [placeholder]=\"'organizations.chooseOwner' | translate\">\n            <ng-template let-item pTemplate=\"selectedItem\">\n              <div>{{item.given_name + ' ' + item.family_name}}</div>\n            </ng-template>\n            <ng-template let-item pTemplate=\"item\">\n              <div>{{item.given_name + ' ' + item.family_name}}</div>\n            </ng-template>\n          </p-dropdown>\n          </div>\n        </div>\n\n        <div class=\"d-flex justify-content-end mt-3\">\n          <button [disabled]=\"!form.valid || !changed()\" type=\"button\" class=\"btn btn-secondary\" (click)=\"save()\" [ladda]=\"loading\"\n                  translate=\"save\"></button>\n        </div>\n      </div>\n    </form>\n    <app-error [error]=\"error\"></app-error>\n  </div>\n</div>\n" }]
        }], ctorParameters: () => [{ type: i1.AuthService }, { type: i1.OrganizationService }, { type: OrganizationUserService }] });

marker('user.title');
class UserComponent {
    constructor(userService, authService, translate, statusBadge, configuration, dateTimePipe) {
        this.userService = userService;
        this.authService = authService;
        this.translate = translate;
        this.statusBadge = statusBadge;
        this.configuration = configuration;
        this.dateTimePipe = dateTimePipe;
        this.customActions = [];
        this.iconActions = [];
        this.showAdminActions = input(false);
    }
    get columns() {
        return [
            new Column('family_name', 'user.family_name', { sortable: true }),
            new Column('given_name', 'user.given_name', { sortable: true }),
            new Column('email', 'user.email', { sortable: true }),
            new Column('role', 'user.role', { translate: true }),
            new Column('status', 'user.status', { sortable: true, pipe: this.statusBadge }),
            new Column('createdAt', 'user.createdAt', { pipe: this.dateTimePipe, sortable: true }),
        ];
    }
    ngOnInit() {
        this.userSource = new NimmstaDataSource(this.userService);
        if (this.showAdminActions() && this.configuration.applicationUrls.workflow) {
            const impersonateAction = new ImpersonateAction('Impersonate on Productivity Cloud', this.authService, 'cloud');
            impersonateAction.subscribe((id) => this.impersonate(id, new URL(this.configuration.applicationUrls.workflow)));
            this.iconActions.push(impersonateAction);
        }
        const editAction = new CustomAction('edit');
        editAction.subscribe((id) => this.edit(id));
        this.customActions.push(editAction);
        const deleteAction = new DeleteUserAction('delete', this.authService);
        deleteAction.subscribe((id) => this.delete(id));
        this.customActions.push(deleteAction);
        const lockUnlockAction = new LockUnlockAction('user.unlock');
        this.customActions.push(lockUnlockAction);
        lockUnlockAction.subscribe((id) => this.toggleLock(id));
    }
    new() {
        this.translate.get('user.new').subscribe((value) => {
            this.openModal(value, true, {});
        });
    }
    edit(id) {
        this.translate.get('user.edit').subscribe((value) => {
            this.openModal(value, true, this.getSelectedObject(id));
        });
    }
    openModal(title, editable, user) {
        this.userFormComponent.editable = editable;
        this.userFormComponent.setValue(user);
        this.editModalComponent.title = title;
        this.editModalComponent.editable = editable;
        const modalRef = this.editModalComponent.show();
        modalRef.setClass('modal-sm');
    }
    delete(id) {
        this.userService.delete(this.getSelectedObject(id)).subscribe({
            next: () => { this.tableComponent.loadDataPage(); },
            error: (error) => { this.error = error; },
        });
    }
    toggleLock(id) {
        const user = this.getSelectedObject(id);
        if (user.status === UserStatus.ACTIVE) {
            this.lock(id);
        }
        else {
            this.unlock(id);
        }
    }
    lock(id) {
        this.userService.lock(this.getSelectedObject(id)).subscribe({
            next: () => { this.tableComponent.loadDataPage(); },
            error: (error) => { this.error = error; },
        });
    }
    unlock(id) {
        this.userService.unlock(this.getSelectedObject(id)).subscribe({
            next: () => { this.tableComponent.loadDataPage(); },
            error: (error) => { this.error = error; },
        });
    }
    onSave() {
        this.userFormComponent.onSave();
    }
    onModalClose() {
        this.editModalComponent.hide();
        this.tableComponent.loadDataPage();
    }
    getSelectedObject(id) {
        return this.userSource.data?.content.filter((d) => id === d.id).pop();
    }
    onLoading(loading) {
        this.editModalComponent.loading = loading;
    }
    impersonate(id, target) {
        if (!this.showAdminActions()) {
            return;
        }
        this.userSource.data?.content.filter((d) => id === d.id).forEach((user) => {
            this.authService.impersonate(user.email).subscribe({
                next: (data) => {
                    const error = launchImpersonationInNewTab(this.authService, data, target);
                    if (error) {
                        this.error = new HttpErrorResponse({
                            error: { error: error.message },
                        });
                    }
                },
                error: (error) => {
                    this.error = new HttpErrorResponse({
                        ...error,
                        error: { ...error.error, error: `httperror.${error.status}` },
                    });
                },
            });
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: UserComponent, deps: [{ token: i1.UserService }, { token: i1.AuthService }, { token: i2.TranslateService }, { token: i1.StatusBadgePipe }, { token: i1.NimmstaCommonsModuleConfiguration }, { token: i1.DateTimePipe }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.1.0", version: "18.2.13", type: UserComponent, selector: "app-user", inputs: { showAdminActions: { classPropertyName: "showAdminActions", publicName: "showAdminActions", isSignal: true, isRequired: false, transformFunction: null } }, viewQueries: [{ propertyName: "tableComponent", first: true, predicate: DataTableComponent, descendants: true, static: true }, { propertyName: "editModalComponent", first: true, predicate: ["EditModal"], descendants: true }, { propertyName: "userFormComponent", first: true, predicate: UserFormComponent, descendants: true, static: true }], ngImport: i0, template: "<app-datatable [dataSource]=\"userSource\" [columns]=\"columns\" [identifier]=\"'users'\" [customActions]=\"customActions\" [iconActions]=\"iconActions\"\n  (newEvent)=\"new()\" (showEvent)=\"edit($event.valueOf())\">\n  <app-empty-table [icon]=\"'person'\" [emptyText]=\"'user.empty_text' | translate\" [buttonText]=\"'user.createNew' | translate\"\n    (btnClick)=\"new()\">\n  </app-empty-table>\n</app-datatable>\n\n<app-error [error]=\"error\"></app-error>\n\n<app-model-modal #EditModal (saveEvent)=\"onSave()\">\n  <app-user-form #form (closeEvent)=\"onModalClose()\" (loadingEvent)=\"onLoading($event.valueOf())\"></app-user-form>\n</app-model-modal>\n", dependencies: [{ kind: "component", type: i1.DataTableComponent, selector: "app-datatable", inputs: ["dataSource", "columns", "identifier", "actionNew", "customActions", "iconActions", "btnClass", "customTableActions", "isMainTable", "loadOnInit", "searchEnabled", "showPagination", "defaultPageSize", "defaultSortName", "defaultSortDirection"], outputs: ["showEvent", "newEvent"] }, { kind: "component", type: i1.AppModelModalComponent, selector: "app-model-modal", inputs: ["title", "editable", "loading", "shakeTime", "secondaryActionText", "secondaryActionEnabled"], outputs: ["saveEvent", "secondaryAction"] }, { kind: "component", type: i1.EmptyTableComponent, selector: "app-empty-table", inputs: ["icon", "emptyText", "buttonText"], outputs: ["btnClick"] }, { kind: "component", type: i1.ErrorComponent, selector: "app-error", inputs: ["error"] }, { kind: "component", type: UserFormComponent, selector: "app-user-form", outputs: ["closeEvent", "loadingEvent"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: UserComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-user', template: "<app-datatable [dataSource]=\"userSource\" [columns]=\"columns\" [identifier]=\"'users'\" [customActions]=\"customActions\" [iconActions]=\"iconActions\"\n  (newEvent)=\"new()\" (showEvent)=\"edit($event.valueOf())\">\n  <app-empty-table [icon]=\"'person'\" [emptyText]=\"'user.empty_text' | translate\" [buttonText]=\"'user.createNew' | translate\"\n    (btnClick)=\"new()\">\n  </app-empty-table>\n</app-datatable>\n\n<app-error [error]=\"error\"></app-error>\n\n<app-model-modal #EditModal (saveEvent)=\"onSave()\">\n  <app-user-form #form (closeEvent)=\"onModalClose()\" (loadingEvent)=\"onLoading($event.valueOf())\"></app-user-form>\n</app-model-modal>\n" }]
        }], ctorParameters: () => [{ type: i1.UserService }, { type: i1.AuthService }, { type: i2.TranslateService }, { type: i1.StatusBadgePipe }, { type: i1.NimmstaCommonsModuleConfiguration }, { type: i1.DateTimePipe }], propDecorators: { tableComponent: [{
                type: ViewChild,
                args: [DataTableComponent, { static: true }]
            }], editModalComponent: [{
                type: ViewChild,
                args: ['EditModal', { static: false }]
            }], userFormComponent: [{
                type: ViewChild,
                args: [UserFormComponent, { static: true }]
            }] } });

class WorkerFormComponent extends SaveableFormComponent {
    get workflowIds() {
        return this.workflows.filter((workflow) => !workflow.isIdle).map((workflow) => workflow.id);
    }
    get workflowNames() {
        return this.workflows.filter((workflow) => !workflow.isIdle).map((workflow) => workflow.name);
    }
    get idleWorkflowIdsWithEmpty() {
        return this.workflows.filter((workflow) => workflow.isIdle).map((workflow) => workflow.id);
    }
    get idleWorkflowNamesWithEmpty() {
        return this.workflows.filter((workflow) => workflow.isIdle).map((workflow) => workflow.name);
    }
    constructor(fb, workerService, workflowService) {
        super(workerService);
        this.fb = fb;
        this.workflowService = workflowService;
        this.closeEvent = new EventEmitter();
        this.loadingEvent = new EventEmitter();
        this.workflows = [];
        const worker = {};
        this.setValue(worker);
    }
    ngOnInit() {
        this.workflowService.simpleList().subscribe((workflows) => {
            this.workflows = workflows;
        });
    }
    setFormGroup() {
        if (!this.value.assignedWorkflowId && this.workflowIds.length === 1) {
            this.value.assignedWorkflowId = this.workflowIds[0];
        }
        this.form = this.fb.group({
            id: this.value.id,
            email: [this.value.email, [Validators.email]],
            given_name: [this.value.given_name, [Validators.required, Validators.minLength(2), Validators.maxLength(30)]],
            family_name: [this.value.family_name, [Validators.required, Validators.minLength(2), Validators.maxLength(30)]],
            assignedWorkflowId: [this.value.assignedWorkflowId, [Validators.required]],
            assignedIdleWorkflowId: this.value.assignedIdleWorkflowId,
            additionalData: this.value.additionalData,
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: WorkerFormComponent, deps: [{ token: i1$1.FormBuilder }, { token: WorkerService }, { token: i1.WorkflowService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: WorkerFormComponent, selector: "app-worker-form", outputs: { closeEvent: "closeEvent", loadingEvent: "loadingEvent" }, usesInheritance: true, ngImport: i0, template: "<form [formGroup]=\"form\">\n  <div class=\"row\">\n    <div class=\"col-md-8 form-group\">\n      <label translate>user.given_name</label>\n      <app-input-with-error [control]=\"this.form.controls['given_name']\"></app-input-with-error>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-md-8 form-group\">\n      <label translate>user.family_name</label>\n      <app-input-with-error [control]=\"this.form.controls['family_name']\"></app-input-with-error>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-md-8 form-group\">\n      <label translate>user.email</label> <label style=\"color: #5d666f; font-size: small;\" class=\"mx-1\">(optional)</label>\n      <app-input-with-error [control]=\"this.form.controls['email']\"></app-input-with-error>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-md-8 form-group\">\n      <label translate>worker.assignedWorkflow</label>\n      <app-input-with-error [control]=\"this.form.controls['assignedWorkflowId']\" [inputType]=\"'select'\" [selectValues]=\"workflowIds\" [selectNames]=\"workflowNames\" selectDefaultText=\"worker.assignedWorkflow_hint\"></app-input-with-error>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-md-8 form-group\">\n      <label translate>worker.assignedIdleWorkflow</label> <label style=\"color: #5d666f; font-size: small;\" class=\"mx-1\">(optional)</label>\n      <app-input-with-error [control]=\"this.form.controls['assignedIdleWorkflowId']\" [inputType]=\"'select'\" [selectValues]=\"idleWorkflowIdsWithEmpty\" [selectNames]=\"idleWorkflowNamesWithEmpty\" selectDefaultText=\"worker.assignedIdleWorkflow_default\" [selectDefaultIsDisabled]=\"false\" ></app-input-with-error>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-md-8 form-group\">\n      <label translate>worker.additionalData</label> <label style=\"color: #5d666f; font-size: small;\" class=\"mx-1\">(optional)</label>\n      <app-input-with-error [control]=\"this.form.controls['additionalData']\"></app-input-with-error>\n    </div>\n  </div>\n  <app-error [error]=\"error\"></app-error>\n</form>\n", dependencies: [{ kind: "directive", type: i1$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.TranslateDirective, selector: "[translate],[ngx-translate]", inputs: ["translate", "translateParams"] }, { kind: "component", type: i1.InputWithErrorComponent, selector: "app-input-with-error", inputs: ["control", "inputType", "selectValues", "selectNames", "type", "description", "selectDefaultText", "selectDefaultIsDisabled", "helpText", "prependIcon", "rows"], outputs: ["keyUpEvent"] }, { kind: "component", type: i1.ErrorComponent, selector: "app-error", inputs: ["error"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: WorkerFormComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-worker-form', template: "<form [formGroup]=\"form\">\n  <div class=\"row\">\n    <div class=\"col-md-8 form-group\">\n      <label translate>user.given_name</label>\n      <app-input-with-error [control]=\"this.form.controls['given_name']\"></app-input-with-error>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-md-8 form-group\">\n      <label translate>user.family_name</label>\n      <app-input-with-error [control]=\"this.form.controls['family_name']\"></app-input-with-error>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-md-8 form-group\">\n      <label translate>user.email</label> <label style=\"color: #5d666f; font-size: small;\" class=\"mx-1\">(optional)</label>\n      <app-input-with-error [control]=\"this.form.controls['email']\"></app-input-with-error>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-md-8 form-group\">\n      <label translate>worker.assignedWorkflow</label>\n      <app-input-with-error [control]=\"this.form.controls['assignedWorkflowId']\" [inputType]=\"'select'\" [selectValues]=\"workflowIds\" [selectNames]=\"workflowNames\" selectDefaultText=\"worker.assignedWorkflow_hint\"></app-input-with-error>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-md-8 form-group\">\n      <label translate>worker.assignedIdleWorkflow</label> <label style=\"color: #5d666f; font-size: small;\" class=\"mx-1\">(optional)</label>\n      <app-input-with-error [control]=\"this.form.controls['assignedIdleWorkflowId']\" [inputType]=\"'select'\" [selectValues]=\"idleWorkflowIdsWithEmpty\" [selectNames]=\"idleWorkflowNamesWithEmpty\" selectDefaultText=\"worker.assignedIdleWorkflow_default\" [selectDefaultIsDisabled]=\"false\" ></app-input-with-error>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-md-8 form-group\">\n      <label translate>worker.additionalData</label> <label style=\"color: #5d666f; font-size: small;\" class=\"mx-1\">(optional)</label>\n      <app-input-with-error [control]=\"this.form.controls['additionalData']\"></app-input-with-error>\n    </div>\n  </div>\n  <app-error [error]=\"error\"></app-error>\n</form>\n" }]
        }], ctorParameters: () => [{ type: i1$1.FormBuilder }, { type: WorkerService }, { type: i1.WorkflowService }], propDecorators: { closeEvent: [{
                type: Output
            }], loadingEvent: [{
                type: Output
            }] } });

marker('worker.pair');
marker('worker.unpair');
class PairUnpairAction extends CustomAction {
    constructor() {
        super('worker.pair', true);
        this.btnClass = 'btn-outline-primary';
    }
    getClass(worker) {
        switch (worker.status) {
            case WorkerStatus.NOT_PAIRED:
                return 'btn-outline-secondary connect';
            case WorkerStatus.PAIRED:
                return 'btn-outline-primary disconnect';
            case WorkerStatus.ACTIVE:
                return 'btn-outline-danger disconnect';
            default:
                throw new Error('Unknown worker status');
        }
    }
    getText(worker) {
        switch (worker.status) {
            case WorkerStatus.NOT_PAIRED:
                return 'worker.pair';
            case WorkerStatus.PAIRED:
                return 'worker.unpair';
            case WorkerStatus.ACTIVE:
                return 'worker.unpair-active';
            default:
                throw new Error('Unknown worker status');
        }
    }
}

class WorkerStatusPipe {
    constructor(translate) {
        this.translate = translate;
    }
    transform(workerStatus) {
        let status;
        let badge;
        switch (workerStatus) {
            case WorkerStatus.PAIRED:
                status = 'worker.paired';
                badge = 'paired';
                break;
            case WorkerStatus.ACTIVE:
                status = 'ACTIVE';
                badge = 'active';
                break;
            default:
                status = 'worker.not_paired';
                badge = 'not-paired';
                break;
        }
        const text = this.translate.instant(status);
        return (`<div class="badge rounded-pill text-bg-light" translate><div class="dot ${badge}"></div>${text}</div>`);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: WorkerStatusPipe, deps: [{ token: i2.TranslateService }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: WorkerStatusPipe, name: "toWorkerStatusBadge" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: WorkerStatusPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'toWorkerStatusBadge',
                }]
        }], ctorParameters: () => [{ type: i2.TranslateService }] });

marker('worker.title');
marker('worker.nav');
class WorkerComponent {
    constructor(workerService, translate, modalService, statusBadge, dateTimePipe) {
        this.workerService = workerService;
        this.translate = translate;
        this.modalService = modalService;
        this.statusBadge = statusBadge;
        this.dateTimePipe = dateTimePipe;
        this.customActions = [];
    }
    get columns() {
        return [
            new Column('family_name', 'user.family_name', { sortable: true }),
            new Column('given_name', 'user.given_name', { sortable: true }),
            new Column('status', 'user.status', { pipe: this.statusBadge }),
            new Column('createdAt', 'createdAt', { pipe: this.dateTimePipe, sortable: true }),
        ];
    }
    ngOnInit() {
        this.workerSource = new NimmstaDataSource(this.workerService);
        const pairAction = new PairUnpairAction();
        this.customActions.push(pairAction);
        pairAction.subscribe((id) => this.pairUnpair(id));
        const editAction = new CustomAction('edit');
        this.customActions.push(editAction);
        editAction.subscribe((id) => this.edit(id));
        const deleteAction = new CustomAction('delete', false, true);
        this.customActions.push(deleteAction);
        deleteAction.subscribe((id) => this.delete(id));
    }
    new() {
        this.translate.get('worker.new').subscribe((value) => {
            this.openModal(value, true, {});
        });
    }
    edit(id) {
        this.translate.get('worker.edit').subscribe((value) => {
            this.openModal(value, true, this.getSelectedObject(id));
        });
    }
    pairUnpair(id) {
        const worker = this.getSelectedObject(id);
        switch (worker.status) {
            case WorkerStatus.NOT_PAIRED:
                this.pair(worker);
                break;
            case WorkerStatus.PAIRED:
                this.unpair(worker);
                break;
            case WorkerStatus.ACTIVE:
                this.unpairActiveWorker(worker);
                break;
        }
    }
    pair(worker) {
        if (this.modalRef !== undefined) {
            this.modalRef.hide();
        }
        this.modalRef = this.modalService.show(PairWorkerModalComponent, {
            initialState: {
                worker,
            },
        });
        const sub = this.modalRef.onHide?.subscribe(() => {
            this.tableComponent.loadDataPage();
            sub?.unsubscribe();
        });
    }
    unpair(worker) {
        lastValueFrom(this.workerService.unpair(worker)).then(() => this.tableComponent.loadDataPage());
    }
    unpairActiveWorker(worker) {
        this.modalRef = this.modalService.show(this.unpairActiveWorkerQuestionModal);
        const sub = this.modalRef.onHide?.subscribe((data) => {
            sub?.unsubscribe();
            if (data === 'unpair') {
                this.unpair(worker);
            }
        });
    }
    openModal(title, editable, worker) {
        this.workerFormComponent.editable = editable;
        this.workerFormComponent.setValue(worker);
        this.editWorkerModalComponent.title = title;
        this.editWorkerModalComponent.editable = editable;
        this.editWorkerModalComponent.show();
    }
    delete(id) {
        lastValueFrom(this.workerService.delete(this.getSelectedObject(id))).then(() => this.tableComponent.loadDataPage());
    }
    onSave() {
        this.workerFormComponent.onSave();
    }
    onModalClose() {
        this.editWorkerModalComponent.hide();
        this.tableComponent.loadDataPage();
    }
    getSelectedObject(id) {
        return this.workerSource.data?.content.filter((d) => id === d.id).pop();
    }
    onLoading(loading) {
        this.editWorkerModalComponent.loading = loading;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: WorkerComponent, deps: [{ token: WorkerService }, { token: i2.TranslateService }, { token: i3$1.BsModalService }, { token: WorkerStatusPipe }, { token: i1.DateTimePipe }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: WorkerComponent, selector: "app-worker", viewQueries: [{ propertyName: "tableComponent", first: true, predicate: DataTableComponent, descendants: true, static: true }, { propertyName: "editWorkerModalComponent", first: true, predicate: ["EditWorkerModal"], descendants: true }, { propertyName: "workerFormComponent", first: true, predicate: WorkerFormComponent, descendants: true, static: true }, { propertyName: "unpairActiveWorkerQuestionModal", first: true, predicate: ["unpairActiveWorkerQuestionModal"], descendants: true, static: true }], ngImport: i0, template: "<app-datatable [dataSource]=\"workerSource\"\n              [columns]=\"columns\"\n              [identifier]=\"'worker'\"\n              [customActions]=\"customActions\"\n              (newEvent)=\"new()\"\n              (showEvent)=\"edit($event.valueOf())\">\n                <app-empty-table [icon]=\"'engineering'\"\n                  [emptyText]=\"'worker.empty_text' | translate\"\n                  [buttonText]=\"'worker.new' | translate\"\n                  (btnClick)=\"new()\">\n                </app-empty-table>\n</app-datatable>\n\n<app-model-modal #EditWorkerModal (saveEvent)=\"onSave()\" >\n  <app-worker-form #form (closeEvent)=\"onModalClose()\"></app-worker-form>\n</app-model-modal>\n\n<ng-template #unpairActiveWorkerQuestionModal>\n  <div class=\"modal-header\">\n    <h4 class=\"modal-title\" translate>worker.unpair-active-question-title</h4>\n    <button type=\"button\" class=\"btn-close\" (click)=\"modalRef?.hide()\" aria-label=\"Close\"></button>\n  </div>\n  <div class=\"modal-body\">\n    <p translate>worker.unpair-active-question</p>\n  </div>\n  <div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-outline-secondary\" (click)=\"modalRef?.hide()\" translate>cancel</button>\n    <button type=\"button\" class=\"btn btn-danger\" (click)=\"modalService.setDismissReason('unpair'); modalRef?.hide()\" translate>worker.unpair</button>\n  </div>\n</ng-template>\n", dependencies: [{ kind: "directive", type: i2.TranslateDirective, selector: "[translate],[ngx-translate]", inputs: ["translate", "translateParams"] }, { kind: "component", type: i1.DataTableComponent, selector: "app-datatable", inputs: ["dataSource", "columns", "identifier", "actionNew", "customActions", "iconActions", "btnClass", "customTableActions", "isMainTable", "loadOnInit", "searchEnabled", "showPagination", "defaultPageSize", "defaultSortName", "defaultSortDirection"], outputs: ["showEvent", "newEvent"] }, { kind: "component", type: i1.AppModelModalComponent, selector: "app-model-modal", inputs: ["title", "editable", "loading", "shakeTime", "secondaryActionText", "secondaryActionEnabled"], outputs: ["saveEvent", "secondaryAction"] }, { kind: "component", type: i1.EmptyTableComponent, selector: "app-empty-table", inputs: ["icon", "emptyText", "buttonText"], outputs: ["btnClick"] }, { kind: "component", type: WorkerFormComponent, selector: "app-worker-form", outputs: ["closeEvent", "loadingEvent"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: WorkerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-worker', template: "<app-datatable [dataSource]=\"workerSource\"\n              [columns]=\"columns\"\n              [identifier]=\"'worker'\"\n              [customActions]=\"customActions\"\n              (newEvent)=\"new()\"\n              (showEvent)=\"edit($event.valueOf())\">\n                <app-empty-table [icon]=\"'engineering'\"\n                  [emptyText]=\"'worker.empty_text' | translate\"\n                  [buttonText]=\"'worker.new' | translate\"\n                  (btnClick)=\"new()\">\n                </app-empty-table>\n</app-datatable>\n\n<app-model-modal #EditWorkerModal (saveEvent)=\"onSave()\" >\n  <app-worker-form #form (closeEvent)=\"onModalClose()\"></app-worker-form>\n</app-model-modal>\n\n<ng-template #unpairActiveWorkerQuestionModal>\n  <div class=\"modal-header\">\n    <h4 class=\"modal-title\" translate>worker.unpair-active-question-title</h4>\n    <button type=\"button\" class=\"btn-close\" (click)=\"modalRef?.hide()\" aria-label=\"Close\"></button>\n  </div>\n  <div class=\"modal-body\">\n    <p translate>worker.unpair-active-question</p>\n  </div>\n  <div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-outline-secondary\" (click)=\"modalRef?.hide()\" translate>cancel</button>\n    <button type=\"button\" class=\"btn btn-danger\" (click)=\"modalService.setDismissReason('unpair'); modalRef?.hide()\" translate>worker.unpair</button>\n  </div>\n</ng-template>\n" }]
        }], ctorParameters: () => [{ type: WorkerService }, { type: i2.TranslateService }, { type: i3$1.BsModalService }, { type: WorkerStatusPipe }, { type: i1.DateTimePipe }], propDecorators: { tableComponent: [{
                type: ViewChild,
                args: [DataTableComponent, { static: true }]
            }], editWorkerModalComponent: [{
                type: ViewChild,
                args: ['EditWorkerModal', { static: false }]
            }], workerFormComponent: [{
                type: ViewChild,
                args: [WorkerFormComponent, { static: true }]
            }], unpairActiveWorkerQuestionModal: [{
                type: ViewChild,
                args: ['unpairActiveWorkerQuestionModal', { static: true }]
            }] } });

var Tabs;
(function (Tabs) {
    Tabs["MANAGER"] = "manager";
    Tabs["WORKER"] = "worker";
})(Tabs || (Tabs = {}));
class UserOverviewComponent extends TabComponent {
    constructor(route, router) {
        super(route, router, 'userOverview', Tabs.MANAGER);
        this.Tabs = Tabs;
        this.loadManager = computed(() => this.currentTab() === Tabs.MANAGER || this.loadedTabs().includes(Tabs.MANAGER));
        this.loadWorker = computed(() => this.currentTab() === Tabs.WORKER || this.loadedTabs().includes(Tabs.WORKER));
        this.showAdminActions = false;
    }
    ngOnInit() {
        super.ngOnInit();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: UserOverviewComponent, deps: [{ token: i1$2.ActivatedRoute }, { token: i1$2.Router }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: UserOverviewComponent, selector: "app-user-overview", usesInheritance: true, ngImport: i0, template: "<div class=\"box\">\n  <div class=\"box-row header\">\n    <app-header-bar [title]=\"'user.title'\"></app-header-bar>\n  </div>\n  <div class=\"box-row content mt-2\">\n    <div class=\"row w-100\">\n      <tabset>\n        <tab heading=\"{{'Manager' | translate}}\" id=\"manager-tab\" (selectTab)=\"selectTab(Tabs.MANAGER)\" [active]=\"currentTab() === Tabs.MANAGER\">\n            <app-user *ngIf=\"loadManager()\" [showAdminActions]=\"showAdminActions\"></app-user>\n        </tab>\n        <tab heading=\"{{'worker.title' | translate}}\" id=\"worker-tab\" (selectTab)=\"selectTab(Tabs.WORKER)\" [active]=\"currentTab() === Tabs.WORKER\">\n            <app-worker *ngIf=\"loadWorker()\"></app-worker>\n        </tab>\n      </tabset>\n    </div>\n  </div>\n</div>\n", dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i1.HeaderBarComponent, selector: "app-header-bar", inputs: ["title", "backRoute", "showDefaultBackButton", "date"] }, { kind: "directive", type: i4.TabDirective, selector: "tab, [tab]", inputs: ["heading", "id", "disabled", "removable", "customClass", "active"], outputs: ["selectTab", "deselect", "removed"], exportAs: ["tab"] }, { kind: "component", type: i4.TabsetComponent, selector: "tabset", inputs: ["vertical", "justified", "type"] }, { kind: "component", type: UserComponent, selector: "app-user", inputs: ["showAdminActions"] }, { kind: "component", type: WorkerComponent, selector: "app-worker" }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: UserOverviewComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-user-overview', template: "<div class=\"box\">\n  <div class=\"box-row header\">\n    <app-header-bar [title]=\"'user.title'\"></app-header-bar>\n  </div>\n  <div class=\"box-row content mt-2\">\n    <div class=\"row w-100\">\n      <tabset>\n        <tab heading=\"{{'Manager' | translate}}\" id=\"manager-tab\" (selectTab)=\"selectTab(Tabs.MANAGER)\" [active]=\"currentTab() === Tabs.MANAGER\">\n            <app-user *ngIf=\"loadManager()\" [showAdminActions]=\"showAdminActions\"></app-user>\n        </tab>\n        <tab heading=\"{{'worker.title' | translate}}\" id=\"worker-tab\" (selectTab)=\"selectTab(Tabs.WORKER)\" [active]=\"currentTab() === Tabs.WORKER\">\n            <app-worker *ngIf=\"loadWorker()\"></app-worker>\n        </tab>\n      </tabset>\n    </div>\n  </div>\n</div>\n" }]
        }], ctorParameters: () => [{ type: i1$2.ActivatedRoute }, { type: i1$2.Router }] });

class AdminUserOverviewComponent extends UserOverviewComponent {
    constructor(route, router) {
        super(route, router);
        this.identifier = 'adminUserOverview';
        this.showAdminActions = true;
    }
    ngOnInit() {
        super.ngOnInit();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: AdminUserOverviewComponent, deps: [{ token: i1$2.ActivatedRoute }, { token: i1$2.Router }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: AdminUserOverviewComponent, selector: "app-admin-user-overview", usesInheritance: true, ngImport: i0, template: "<div class=\"box\">\n  <div class=\"box-row header\">\n    <app-header-bar [title]=\"'user.title'\"></app-header-bar>\n  </div>\n  <div class=\"box-row content mt-2\">\n    <div class=\"row w-100\">\n      <tabset>\n        <tab heading=\"{{'Manager' | translate}}\" id=\"manager-tab\" (selectTab)=\"selectTab(Tabs.MANAGER)\" [active]=\"currentTab() === Tabs.MANAGER\">\n            <app-user *ngIf=\"loadManager()\" [showAdminActions]=\"showAdminActions\"></app-user>\n        </tab>\n        <tab heading=\"{{'worker.title' | translate}}\" id=\"worker-tab\" (selectTab)=\"selectTab(Tabs.WORKER)\" [active]=\"currentTab() === Tabs.WORKER\">\n            <app-worker *ngIf=\"loadWorker()\"></app-worker>\n        </tab>\n      </tabset>\n    </div>\n  </div>\n</div>\n", dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i1.HeaderBarComponent, selector: "app-header-bar", inputs: ["title", "backRoute", "showDefaultBackButton", "date"] }, { kind: "directive", type: i4.TabDirective, selector: "tab, [tab]", inputs: ["heading", "id", "disabled", "removable", "customClass", "active"], outputs: ["selectTab", "deselect", "removed"], exportAs: ["tab"] }, { kind: "component", type: i4.TabsetComponent, selector: "tabset", inputs: ["vertical", "justified", "type"] }, { kind: "component", type: UserComponent, selector: "app-user", inputs: ["showAdminActions"] }, { kind: "component", type: WorkerComponent, selector: "app-worker" }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: AdminUserOverviewComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-admin-user-overview', template: "<div class=\"box\">\n  <div class=\"box-row header\">\n    <app-header-bar [title]=\"'user.title'\"></app-header-bar>\n  </div>\n  <div class=\"box-row content mt-2\">\n    <div class=\"row w-100\">\n      <tabset>\n        <tab heading=\"{{'Manager' | translate}}\" id=\"manager-tab\" (selectTab)=\"selectTab(Tabs.MANAGER)\" [active]=\"currentTab() === Tabs.MANAGER\">\n            <app-user *ngIf=\"loadManager()\" [showAdminActions]=\"showAdminActions\"></app-user>\n        </tab>\n        <tab heading=\"{{'worker.title' | translate}}\" id=\"worker-tab\" (selectTab)=\"selectTab(Tabs.WORKER)\" [active]=\"currentTab() === Tabs.WORKER\">\n            <app-worker *ngIf=\"loadWorker()\"></app-worker>\n        </tab>\n      </tabset>\n    </div>\n  </div>\n</div>\n" }]
        }], ctorParameters: () => [{ type: i1$2.ActivatedRoute }, { type: i1$2.Router }] });

class PagesModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PagesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: PagesModule, declarations: [ConfigurationCustomerWrapperComponent,
            ConfigurationListComponent,
            ConfigurationOrgFormComponent,
            OrganizationFormComponent,
            ConfigurationDownloadFormComponent,
            OrganizationUserComponent,
            OrganizationsComponent,
            UserComponent,
            UserFormComponent,
            UserOverviewComponent,
            AdminUserOverviewComponent,
            WorkerComponent,
            WorkerFormComponent,
            PlatformPipe,
            OrganizationNamePipe,
            ConfigStatePipe,
            OrganizationTypePipe,
            OrganizationSettingsComponent], imports: [NimmstaCommonsModule,
            ComponentsModule,
            TabsModule,
            TranslateModule,
            ReactiveFormsModule,
            DropdownModule,
            MultiSelectModule], exports: [ComponentsModule,
            ConfigurationCustomerWrapperComponent,
            ConfigurationListComponent,
            OrganizationUserComponent,
            OrganizationsComponent,
            UserOverviewComponent,
            AdminUserOverviewComponent,
            WorkerComponent,
            OrganizationNamePipe,
            OrganizationSettingsComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PagesModule, providers: [
            WorkerStatusPipe,
            StatusBadgePipe,
            PlatformPipe,
            OrganizationNamePipe,
            ConfigStatePipe,
            OrganizationTypePipe,
        ], imports: [NimmstaCommonsModule,
            ComponentsModule,
            TabsModule,
            TranslateModule,
            ReactiveFormsModule,
            DropdownModule,
            MultiSelectModule, ComponentsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: PagesModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        NimmstaCommonsModule,
                        ComponentsModule,
                        TabsModule,
                        TranslateModule,
                        ReactiveFormsModule,
                        DropdownModule,
                        MultiSelectModule,
                    ],
                    declarations: [
                        ConfigurationCustomerWrapperComponent,
                        ConfigurationListComponent,
                        ConfigurationOrgFormComponent,
                        OrganizationFormComponent,
                        ConfigurationDownloadFormComponent,
                        OrganizationUserComponent,
                        OrganizationsComponent,
                        UserComponent,
                        UserFormComponent,
                        UserOverviewComponent,
                        AdminUserOverviewComponent,
                        WorkerComponent,
                        WorkerFormComponent,
                        PlatformPipe,
                        OrganizationNamePipe,
                        ConfigStatePipe,
                        OrganizationTypePipe,
                        OrganizationSettingsComponent,
                    ],
                    exports: [
                        ComponentsModule,
                        ConfigurationCustomerWrapperComponent,
                        ConfigurationListComponent,
                        OrganizationUserComponent,
                        OrganizationsComponent,
                        UserOverviewComponent,
                        AdminUserOverviewComponent,
                        WorkerComponent,
                        OrganizationNamePipe,
                        OrganizationSettingsComponent,
                    ],
                    providers: [
                        WorkerStatusPipe,
                        StatusBadgePipe,
                        PlatformPipe,
                        OrganizationNamePipe,
                        ConfigStatePipe,
                        OrganizationTypePipe,
                    ],
                }]
        }] });

class ContentFoldersService extends WorkflowDataService {
    get apiEndpoint() {
        return '/content/folder';
    }
    create(object) {
        return this.http.post(`${this.baseUrl}/content`, object, { headers: this.getHeades() }).pipe(map(this.loadedDataTransform));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ContentFoldersService, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ContentFoldersService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ContentFoldersService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class ContentPagesService extends WorkflowDataService {
    get apiEndpoint() {
        return '/content/page';
    }
    create(object) {
        return this.http.post(`${this.baseUrl}/content`, object, { headers: this.getHeades() }).pipe(map(this.loadedDataTransform));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ContentPagesService, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ContentPagesService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ContentPagesService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

/*
 * Public API Surface of nimmsta-angular-b2b-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AdminUserOverviewComponent, ComponentsModule, ConfigurationCustomerWrapperComponent, ConfigurationListComponent, ContentFoldersService, ContentPagesService, OrganizationNamePipe, OrganizationNameService, OrganizationSelectorComponent, OrganizationSettingsComponent, OrganizationUserComponent, OrganizationsComponent, PagesModule, PairWorkerModalComponent, UserComponent, UserOverviewComponent, WorkerComponent };
